
define(
	'C3.ShoppingExtensions.HomeHeader'
,   [
		'C3.ShoppingExtensions.HomeHeader.View',
		'Utils',
		'Profile.Model',
		'C3.ShoppingExtensions.HomeExt.View',
		'Header.MiniCart.View',
		'Home.View',
		'Header.View',
		'C3.ShoppingExtensions.HomeHeader.View',
		'Facets.FacetedNavigationItem.View',
		'C3.ShoppingExtensions.HeaderMenu.AdditionalLevel.View',
		'C3.ShoppingExtensions.HeaderMenu.MyAccountMobile.View',
		'C3.ShoppingExtensions.HeaderMenu.MobileMyAccount.Sidebar',
		'Header.Menu.MyAccount.View',
		/*'C3.ShoppingExtensions.Carousel.View',*/
		'C3.ShoppingExtensions.Carousel.ItemsViewUpdated',
		'Facets.ItemCell.View',
		'ProductViews.Price.View',
		'Session',
		'Facets.Browse.View',
		'Facets.Browse.CategoryHeading.View',
		'Facets.CategoryCell.View',
		'GlobalViews.Breadcrumb.View',
		'C3.ShoppingExtensions.ManufacturerPage.View',
		'C3.ShoppingExtensions.System8Page.View',
		'C3.ShoppingExtensions.System8Page.List.View',
		'Facets.FacetedNavigationItemCategory.View',
		'C3.ShoppingExtensions.SubCategory.Circles.View',
		'Facets.FacetedNavigation.View',
		'ProductDetails.Base.View',
		'LiveOrder.Model',
		'C3.ShoppingExtensions.GroupAddToCart.View',
		'Product.Model',
		'AjaxRequestsKiller',
		'Item.Model',
		'Backbone.CollectionView',
		'facets_item_cell_grid.tpl',
		'facets_items_collection_view_cell.tpl',
		'facets_items_collection_view_row.tpl',
		'facets_items_collection.tpl',
		'c3_shoppingextensions_subcategory_circles.tpl',
		'facets_custom_categories_cell_grid.tpl',
		'C3.ShoppingExtensions.LoginRegister.View',
		'Header.Menu.View',
		'RequestQuoteAccessPoints.HeaderLink.View',
		'C3.ShoppingExtensions.RequestQuoteWizardHeader.View',
		'C3.ShoppingExtensions.NewArrivals.Home.View',
		'GoogleTagManager',
		'Tracker',
		'UrlHelper',
		'Header.MiniCartItemCell.View',
		'js.cookie',
		'GlobalViews.HostSelector.View',
		'C3.ShoppingExtensions.HeaderMenu.GetCategoryItemsCount.Model'

	]
,   function (
		HomeHeaderView,
		Utils,
		ProfileModel,
		HomeHeroSliderView,
		HeaderMiniCartView,
		HomeView,
		HeaderView,
		HeaderViewExt,
		FacetsFacetedNavigationItemView,
		MenuAdditionalLevelView,
		HeaderMenuMyAccountMobileView,
		HeaderExtensionMobileMyAccountSidebar,
		HeaderMenuMyAccountView,
		CarouselView,
		FacetsItemCellView,
		ProductViewsPriceView,
		Session,
		FacetsBrowseView,
		FacetsBrowseCategoryHeadingView,
		FacetsCategoryCellView,
		GlobalViewsBreadcrumbView,
		C3ShoppingExtensionsManufacturerPageView,
		C3ShoppingExtensionsSystem8PageView,
		C3ShoppingExtensionsSystem8PageListView,
		FacetsFacetedNavigationItemCategoryView,
		C3ShoppingExtensionsSubCategoryCirclesView,
		FacetsFacetedNavigationView,
		ProductDetailsBaseView,
		LiveOrderModel,
		GroupAddToCart,
		ProductModel,
		AjaxRequestsKiller,
		ItemModel,
		BackboneCollectionView,
		facets_item_cell_grid_tpl,
		facets_items_collection_view_cell_tpl,
		facets_items_collection_view_row_tpl,
		facets_items_collection_tpl,
		c3_shoppingextensions_subcategory_circles_tpl,
		facets_custom_categories_cell_grid_tpl,
		LoginRegisterView,
		HeaderMenuView,
		RequestQuoteWizardHeaderLinkView,
		RequestQuoteWizardHeaderView,
		NewArrivalsHomeView,
		GoogleTagManager,
		Tracker,
		UrlHelper,
		HeaderMiniCartItemCellView,
		Cookies,
		GlobalViewsHostSelectorView,
		GetCategoryItemsCountModel

	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{

			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var environment = container.getComponent("Environment");
			var Configuration = environment.application.Configuration;

			var nav_data = Configuration.navigationData
			if (typeof window !== 'undefined') {
			$.getJSON("https://api.ipify.org?format=jsonp&callback=?", function(ipData) {
				$.getJSON("https://api.ipinfo.io/lite/" + ipData.ip + "?token=2b1809a42ee55a", function(response)
				{
					setTimeout(function()
					{
						if(!Cookies.get('localizationcountry')){
							Cookies.set('localizationcountry', response.country_code, { expires: 30 });
							jQuery('#site-localization #site-country').text(response.country_code);
							jQuery('#country').val(response.country_code);
						}

						if(!Cookies.get('localizationlanguage')){
							Cookies.set('localizationlanguage', "en", { expires: 30 });
							jQuery('#site-localization #site-language').text("en");
						}

	                }, 2000);

				}).fail(function() {});
			}).fail(function() {});
			}
            container.getLayout().once('afterAppendView', function() {
            	jQuery.getScript( "https://translate.google.com/translate_a/element.js" )
                    .done(function() {
                    	//console.log('in done function');
                    	setTimeout(function() {
                        	return new google.translate.TranslateElement({pageLanguage: 'en' , includedLanguages : 'en,es,pt,de,ko,it,fr,tr,ja,ar'}, 'google_translate_element');
                    	}, 1000);
                    })
                    .fail(function(jqXhr) {
                        jqXhr.preventDefault = true;
                        console.warn('Google Translator was unable to load');
                    });

                // Fetch category item counts once on app load, with 30-min TTL cache
                /*var cacheTime = localStorage.getItem('CategoryWiseItemsCount_time');
                var isStale = !cacheTime || (Date.now() - parseInt(cacheTime, 10)) > 1800000;

                if (!localStorage.getItem('CategoryWiseItemsCount') || isStale) {
                    var model = new GetCategoryItemsCountModel();
                    model.fetch({
                        data: { requestType: 'ALL' },
                        killerId: AjaxRequestsKiller.getKillerId()
                    }).done(function (responseData) {
                        var data = responseData.categoryWiseItemsCountData;
                        localStorage.setItem('CategoryWiseItemsCount', JSON.stringify(data));
                        localStorage.setItem('CategoryWiseItemsCount_time', Date.now().toString());
                    });
                }*/
             });

            layout.addToViewEventsDefinition(
				'Header.View',
				'change [data-action="selectlanguage"]',
				function (e) 
				{
					return true;
				}) 

           layout.addToViewEventsDefinition(
				'Header.View',
				'click [data-action="selectlanguage"]',
				function (e) 
				{
					e.stopPropagation();
					e.preventDefault();
				})

           layout.addToViewEventsDefinition(
				'Header.View',
				'change [data-action="selectcountry"]',
				function (e) 
				{
					return true;
				}) 

           layout.addToViewEventsDefinition(
				'Header.View',
				'click [data-action="selectcountry"]',
				function (e) 
				{
					e.stopPropagation();
					e.preventDefault();
				})

           layout.addToViewEventsDefinition(
				'Header.View',
				'click [data-action="submit-country-language"]',
				function (e) 
				{
					e.preventDefault();

					const triggerEvent = (element, eventName) => {
					  		const event = new Event(eventName);
					  		element.dispatchEvent(event);
					};
					
					const data = (jQuery(e.target).closest('form')).serializeObject();
         			var country = data.country
         			,   language = data.language
					,	ele = jQuery('#google_translate_element')
         			,   findSelect = ele.find('select')
         			//ele.find('select')

         			if(findSelect)
         			{
         				//findSelect.val(language);
         				//findSelect.trigger('click');
         				
         				jQuery('.goog-te-combo').trigger("change").val(language);
         				triggerEvent(document.querySelector('.goog-te-combo'), 'change');
         				
         				if(country) {
							jQuery('#site-localization #site-country').text(country);
							Cookies.set('localizationcountry', country, { expires: 30 });
						}
						if(language) {
							jQuery('#site-localization #site-language').text(language);
							Cookies.set('localizationlanguage', language, { expires: 30 });
						}
         				
         			}
					
				})
				
			GlobalViewsHostSelectorView.prototype.setHost = HeaderViewExt.setHost;  	   


			HeaderMenuMyAccountView.prototype.getContext = _.wrap(HeaderMenuMyAccountView.prototype.getContext, function (fn) {
				var result = fn.apply(this, arguments);

				var finalEntries = result.entries.splice(5,1);
             	//console.log(finalEntries)
				_.extend(result, {
					
				})

				return result;
		     });

			layout.addToViewContextDefinition('Header.View', 'countries', 'array', function(context) {
						var countries = _.values(Configuration.get('siteSettings.countries'))
						
						var selectedCountry = Cookies.get('localizationcountry');

						if(selectedCountry){
							_.each(countries,function(country){
				            	if(country.code == selectedCountry){
				            		//selectedCountryName = country.name
				            		country.isActive = true;
				            	}
				            });
			            }

			           // console.log(selectedCountry)

						return countries;
			      });

             layout.addToViewContextDefinition('Header.View', 'languages', 'array', function(context) {
						

						var LanguageSelector = Configuration.LanguageSelector
	                    ,   LanguageSelectorConfig = LanguageSelector.config

	                    //console.log(LanguageSelectorConfig)

						var selectedLanguage = Cookies.get('localizationlanguage');

						if(selectedLanguage){
							_.each(LanguageSelectorConfig,function(language){
				            	if(language.code == selectedLanguage){
				            		language.isActive = true;
				            	}
				            });
			            }
						//console.log(languages)
						return LanguageSelectorConfig;
			      });

             layout.addToViewContextDefinition('Header.View', 'localizationcountry', 'string', function(context) {
						/*if(!Cookies.get('localizationcountry'))
			           		Cookies.set('localizationcountry',"");*/
					    return Cookies.get('localizationcountry');
			      });
 			
 			layout.addToViewContextDefinition('Header.View', 'localizationlanguage', 'string', function(context) {
						/*if(!Cookies.get('localizationlanguage'))
			           		Cookies.set('localizationlanguage',"");*/
					    return Cookies.get('localizationlanguage');
			      });

			layout.addToViewContextDefinition('Footer.View', 'currentYear', 'boolean', function(context) {
			           var currentDate = new Date()
					   ,   currentYear = currentDate.getFullYear()

					   //console.log(currentYear)
			            return currentYear;
			      });

				layout.addToViewContextDefinition('SC.Shopping.Layout', 'bannerContent', 'string', function(context) {
			            var bannerConfig = Configuration.HeaderBannerContent
			            ,   bannerContent = bannerConfig.config;

			           // console.log(bannerContent)
			            return bannerContent;
			      });

				layout.addToViewContextDefinition('Header.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      });

					layout.addToViewContextDefinition('Header.Menu.View', 'headerLogo', 'boolean', function(context) {
			           
			            var header = Configuration.header
			            ,   logoUrl = header.logoUrl

			             //console.log(logoUrl)
			            return logoUrl;
			      });

				layout.addToViewContextDefinition('Home.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      });

				layout.addToViewContextDefinition('Header.View', 'safariBrowserMac', 'boolean', function(context) {
			            return (typeof navigator !== 'undefined' && navigator.vendor.indexOf('Apple') > -1) ? true : false;
			      });

				layout.addToViewContextDefinition('Cart.Lines.View', 'isPhoneDevice', 'boolean', function(context) {
			            
			            return Utils.isPhoneDevice();
			      });

	            layout.addToViewContextDefinition('Cart.Detailed.View', 'isPhoneDevice', 'boolean', function(context) {
				            //console.log(Utils.isPhoneDevice())
				            return Utils.isPhoneDevice();
				      });

	            layout.addToViewContextDefinition('Facets.ItemListSortSelector.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      });

			layout.addToViewContextDefinition('Facets.ItemListSortSelector.View', 'isTabletPhoneDevice', 'boolean', function(context) {
			            
			            return Utils.isTabletDevice() || Utils.isPhoneDevice();
			      });

            layout.addToViewContextDefinition('Facets.FacetedNavigation.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      });

            /*layout.addToViewContextDefinition('Header.View', 'isLoggedIn', 'boolean', function(context) {
			            return (profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F');
			      });*/

            layout.addToViewContextDefinition('Header.View', 'showOneTime', 'boolean', function(context) {
			           var isLoggedIn = context.profileModel.isLoggedIn;
			           var fireFirstTime = false;

			           if(isLoggedIn == "T")
			           {
			           	if(!Cookies.get('firstTimeLoginFiring'))
			           	{
			           		Cookies.set('firstTimeLoginFiring',true);
			           		fireFirstTime = true;
			           	}
			           }

			           //console.log(fireFirstTime)
			           
			           return fireFirstTime;
			      });

            layout.addToViewContextDefinition('Header.View', 'isLoggedIn', 'boolean', function(context) {
			          
			           return (context.profileModel.isLoggedIn == "T" ? true : false)
			      });

           layout.addToViewEventsDefinition(
				'Header.View',
				'click [data-action="take-to-login-first"]',
				function (e) 
				{
					let login = Session.get('touchpoints.login');

		            login += '&origin=' + Configuration.currentTouchpoint;

		            login += '&origin_hash=inventory-list';
		            window.location.href = login;
				})    

             layout.addToViewContextDefinition('Header.View', 'isTabletPhoneDevice', 'boolean', function(context) {
			            
			            return Utils.isTabletDevice() || Utils.isPhoneDevice();
			      });

              layout.addToViewContextDefinition('Header.Profile.View', 'isTabletPhoneDevice', 'boolean', function(context) {
			            
			            return Utils.isTabletDevice() || Utils.isPhoneDevice();
			      });

              layout.addToViewContextDefinition('Header.Menu.View', 'isTabletPhoneDevice', 'boolean', function(context) {
			            
			            return Utils.isTabletDevice() || Utils.isPhoneDevice();
			      });


             layout.addToViewContextDefinition('SiteSearch.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      });

              layout.addToViewContextDefinition('Header.Profile.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      });


              layout.addToViewContextDefinition('Header.Menu.View', 'displayName', 'string', function(context) {
			        	//console.log(context)
			            return context.profileModel.firstname || context.profileModel.companyname;
			      });

              layout.addToViewContextDefinition('Header.Menu.View', 'isLoggedIn', 'boolean', function(context) {
			           // console.log(context)
			            return (context.profileModel.isLoggedIn === 'T' && context.profileModel.isGuest === 'F');
			      });

              layout.addChildView('HomeHeroSlider', function () {
				//console.log(layout)
			  return new HomeHeroSliderView({
			  	application : layout.application
			  });
			});

            layout.addChildView('QuoteItemsCount', function () {

            	var profile = ProfileModel.getInstance()
			    ,   is_logged_in = (profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F')
           			
				if(profile.get('isLoggedIn') == 'T' && profile.get('isGuest') == 'F'){
					var itemsInQuote = ''

					return new RequestQuoteWizardHeaderView({
						  	application : layout.application,
						  	profile : profile
						  });
				}

				return null;
			  	
			});

              /*RequestQuoteWizardHeaderLinkView.prototype.getContext = _.wrap(RequestQuoteWizardHeaderLinkView.prototype.getContext, function (fn) {
				var result = fn.apply(this, arguments);	


				if(profile.get('isLoggedIn') == 'T' && profile.get('isGuest') == 'F'){
					var itemsInQuote = ''
					layout.application.ProductListModule.Utils.getRequestAQuoteProductList().done(function(product_list_json){
						//console.log(product_list_json)
						if(product_list_json)
						itemsInQuote = product_list_json.items;
					});
					setTimeout(function() {
						console.log(itemsInQuote)
					}, 2090)	
				}

				_.extend(result, {
					
				})	
				//console.log(result)
				return result;
		     });*/     

            layout.addChildView('Header.Menu.MyAccount.Mobile', function () 
		        {
		        	//console.log(layout)
		          return new HeaderMenuMyAccountMobileView(
		                {application: layout.application});
		        });

		         layout.addChildView('Header.Sidebar.Mobile.MyAccount.Menu', function () 
		        {
		        	//console.log(layout)
		          return new HeaderMenuMyAccountView(
		                {application: layout.application});
		        });

		         layout.addChildView('C3.MyAccount.Mobile.Header.Menu', function () 
		        {
		        	var header_view_options = _.extend(
	                {
	                    application: layout.application
	                },
	                {}
	            );

	            return new HeaderExtensionMobileMyAccountSidebar(header_view_options);
		        });

              layout.addToViewContextDefinition('GlobalViews.Pagination.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      });  

               layout.addToViewContextDefinition('Header.Menu.MyAccount.View', 'entries', 'string', function(context) {
             	var entries=context.entries;
             	var finalizedTranArray = []
             			
             	_.each(entries,function(menu){
             		if(menu.id == "orders"){
             			menu.name = 'Transaction History';
             			finalizedTranArray = {
             				id: "orders",
             				index: 2,
             				name: "Transaction History",
             				permission: "transactions.tranSalesOrd.1,transactions.tranEstimate.1,transactions.tranRtnAuth.1",
             				permissionOperator:  "OR",
             				showChildren: true,
             				url: "",
             				children : [
	             				{
	             					entryId : "orders",
		             				id : "balance",
					     			name : "Account Balance",
					     			url : "/balance",
					     			index : 0
	             				},
	             				{
		             				entryId : "orders",
		             				id : "quotes",
					     			name : "Quotes",
					     			url : "/quotes",
					     			permission: "transactions.tranFind.1,transactions.tranEstimate.1",
					     			index : 1
	             			    },
	             			    {
	             			    	entryId : "orders",
		             				id : "purchases",
					     			name : "Sales Orders",
					     			url : "/salesorders",
					     			index : 2
	             			    },
	             			    {
	             			    	entryId : "orders",
		             				id : "all-invoices",
					     			name : "Invoices",
					     			url : "/all-invoices",
					     			permission : "transactions.tranCustInvc.1",
					     			index : 3
	             			    },
	             			    {
	             			    	entryId : "orders",
		             				id : "transactionhistory",
					     			name : "Transaction History",
					     			url : "/transactionhistory",
					     			permission: "transactions.tranCustInvc.1, transactions.tranCustCred.1, transactions.tranCustPymt.1, transactions.tranCustDep.1, transactions.tranDepAppl.1",
					     			permissionOperator: "OR",
					     			index : 4
	             			    },
	             			    {
	             			    	entryId : "orders",
		             				id : "returns",
					     			name : "Returns",
					     			url : "/returns",
					     			permission : "transactions.tranFind.1,transactions.tranRtnAuth.1",
					     			index : 5
	             			    },
	             			    {
	             			    	entryId : "orders",
		             				id : "reorderitems",
					     			name : "Reorder Items",
					     			url : "/reorderItems",
					     			permission : "transactions.tranFind.1,transactions.tranSalesOrd.1",
					     			index : 6
	             			    },
	             			    {
	             			    	entryId : "orders",
		             				id : "printstatement",
					     			name : "Print a Statement",
					     			url : "/printstatement",
					     			permission : "transactions.tranStatement.2",
					     			index : 7
	             			    }
             				]
             			}
             		}
             		else if(menu.id == "settings"){
             			menu.children[0].name = 'Profile'
             			menu.children[0].url = '/profile-information'
             			menu.children[1].url = '/email-preferences'
             			menu.children[1].id = 'email-preferences'
             			menu.children[2].name = 'Addresses'
             			menu.children[3].name = 'Payments'
             			menu.children[4].url = '/profile-information'
             			menu.children.splice(4,1);
             		}
             	});

             	entries.splice(1,1,finalizedTranArray);
             	entries.splice(3,1)

				//console.log(entries)
             	

				 return entries; 
             });  

          
        
        
        HeaderMiniCartItemCellView.prototype.getContext = _.wrap(HeaderMiniCartItemCellView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);	
        	
        	var item = this.model.get('item')
			,   price_container_object = this.model.getPrice()
			,   pricelevel1 = ''
			,   pricelevel5 = ''
			,   pricelevel1_formatted = ''
			,   onlinecustomerprice_detail = ''
			,   applyStrikeThroughPrice = false
			,   onlineprice = ''
			,   special_formatted_pricelevel1 = ''
			,   special_formatted_pricelevel5 = ''
			,   isKitItemOnly = ''
			,   showOutofStock = false
			,	savePrice = 0
			,	savePercent=0
			,	discountPercentage=0;

			if(item)
			{
				pricelevel1 = item.get('pricelevel1')
				pricelevel1_formatted = item.get('pricelevel1_formatted')
				pricelevel5 = item.get('onlinecustomerprice')
				onlinecustomerprice_detail = item.get('onlinecustomerprice_detail')
				if(onlinecustomerprice_detail)
				onlineprice = onlinecustomerprice_detail.onlinecustomerprice

				var qtyAvailableInv = item.get('custitem_qty_available_inv')
	            ,   qtyAvailableKit = item.get('custitem_qty_available_kit')
	            ,   itemType = item.get('itemtype')
	            ,   enableOutOfStock = item.get('custitem_celigo_shopify_enable_out_sto')
	            ,   isWebsiteCategoryProduct = item.get('custitem157')
	            ,   isKitItemOnly = item.get('custitem_kit_item_only') 

	            if(qtyAvailableInv == undefined)
				qtyAvailableInv = 0;

				if(qtyAvailableKit == undefined)
				qtyAvailableKit = 0;
	           
	            if(itemType == "Kit")
	            {
	                //Item Qty is 0 and Allow out of stock checkbox is not checked
	                if(qtyAvailableKit <= 0 && enableOutOfStock == false)
	                {
	                    showOutofStock = true;
	                }
	            }
	            else if(itemType == 'InvtPart' || itemType == 'Assembly')
	            {
	                //Item Qty is 0 and Allow out of stock checkbox is not checked
	                if(qtyAvailableInv <= 0 && enableOutOfStock == false)
	                {
	                    showOutofStock = true;
	                }
	            }

				if(pricelevel1 && pricelevel1 > onlineprice)
				{
					//console.log(pricelevel1.toLocaleString('en'));
					applyStrikeThroughPrice = true;
				}
				//console.log(pricelevel1_formatted)
				if(pricelevel1_formatted)
				special_formatted_pricelevel1 = pricelevel1_formatted.substr(0, pricelevel1_formatted.indexOf('.'));
				
				if(price_container_object)
				{
					onlineprice = price_container_object.price_formatted;
					if(onlineprice)
					special_formatted_pricelevel5 = onlineprice.substr(0, onlineprice.indexOf('.'));
				}	

				var currPrice = pricelevel5 || pricelevel1 || 0; 
                if( currPrice < 5){
                    showOutofStock = true;
                } 
			}

			if(isKitItemOnly == true)
                showOutofStock = true;

            if(applyStrikeThroughPrice)
            {
            	savePrice = parseFloat((Number(pricelevel1) - Number(pricelevel5)).toFixed(2));
            	discountPercentage = (savePrice / pricelevel1) * 100;
            	savePercent=Math.trunc(discountPercentage)+ "%";
            }

             //img src based on item option in cart
            var itemOptions = this.model.get('options')
	            ,   findOptionImg = ''
	            ,   findOptionPrice = ''
	            ,   findOptionCosmetic = ''
	            ,   findOptionFunctional = ''
	            ,   findOptionDisposable = ''
	            if(itemOptions.length > 0)
	            {
	            	var line_options_models =  itemOptions.models  
	            	,   targetImgId = "custcol_inventory_number_image"
	            	,   targetPriceId = "custcol_webstore_asset_price"
	            	,   targetId = 'custcol_webstore_temp_data'

	            	//console.log(line_options_models)
	            	if(line_options_models.length > 0)
	                   {

	               		var filteredOptions = line_options_models.find(option => option.get('cartOptionId') === targetId)
		                   if(filteredOptions){
			                   var getOptionValue = filteredOptions.get('value')
			                   if(getOptionValue){
				                   var optionInteralid = getOptionValue.internalid;
				                   if(optionInteralid){
				                   	var parsedInfo = JSON.parse(optionInteralid)
				                   	findOptionCosmetic = parsedInfo.cosmetic
				                   	findOptionFunctional = parsedInfo.functional
				                   	findOptionDisposable = parsedInfo.disposable
				                   	findOptionImg = parsedInfo.imgurl;
				                   	findOptionPrice = parsedInfo.price;
				                   }
				                  
			              	   }

		               		}
	                   }

	            }

            
			_.extend(result, {					
							applyStrikeThroughPrice : applyStrikeThroughPrice,
							BasePriceFormatted : special_formatted_pricelevel1,
							OnlinePriceFormatted : special_formatted_pricelevel5,
						    hidePrice : showOutofStock,
							savePrice : savePrice,
							savePercent:savePercent,
						    optionImg : findOptionImg,
						    optionPrice : Utils.formatCurrency(findOptionPrice),
							optionCosmetic : findOptionCosmetic,
							optionFunctional : findOptionFunctional,
							optionDisposable : findOptionDisposable
						});

			//console.log(result)
			return result;
	     });

        HeaderMiniCartView.prototype.getContext = _.wrap(HeaderMiniCartView.prototype.getContext, function (fn) {
				var result = fn.apply(this, arguments);	

				
				var cartItemCount = result.itemsInCart
				,   cartItemCountText = '0'
				,   hasMoreThanOne = false
				,   strykerUSRestriction = false
				,   blockMiniCartToCheckout = false

				if(cartItemCount > 9){
					cartItemCountText = '9⁺'
					hasMoreThanOne = true;
				}else{
					cartItemCountText = cartItemCount;
				}
				
				//console.log(this)

				var currentPage = $(location).attr('href');

				/*var lines = this.model.get('lines')
				,  linesModel = lines.models
				,   itemHasNoAvailableQuantity = false
				,   strykerProduct = false

				_.each(linesModel,function(line){

					var item = line.get('item')
					,   type = item.get('itemtype')
					,   qtyAvailableInv = item.get('custitem_qty_available_inv')
				    ,   qtyAvailableKit = item.get('custitem_qty_available_kit') 
				    ,   manufacturerName = item.get('custitem_manufacturer')  
				     

				    //console.log(manufacturerName)
				    if(manufacturerName == 'Stryker')
				    	strykerProduct = true;

					if(type == 'Kit')
					{
						if(qtyAvailableKit < 1){
							itemHasNoAvailableQuantity = true;
							blockMiniCartToCheckout = true;
						}
						
					}
					else if(type == 'InvtPart')
					{
						if(qtyAvailableInv < 1){
							itemHasNoAvailableQuantity = true;
							blockMiniCartToCheckout = true;
						}
						
					}

				});*/

				//Stryker shipping to US restriction functionality
				/*if(profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F')
				{
					var addressBook = profile.get('addressbook');

	                var find_shippingAddr = _.findWhere(addressBook, {
	                    defaultshipping: 'T'
	                });

	                if(find_shippingAddr)
	                {

                    	var srtykerResitrictCountries = Configuration.StrykerRestrictedCountries
	                    ,   srtykerResitrictConfig = srtykerResitrictCountries.config

	                    
	                    _.each(srtykerResitrictConfig,function(country){
	                    	if(country.countrycode == find_shippingAddr.country && strykerProduct)
	                    	{
	                    		strykerUSRestriction = true;
	                    		blockMiniCartToCheckout = true;
	                    	}
	                    })
	                }
				}*/

				_.extend(result, {
					cartItemCountText : cartItemCountText,
					hasMoreThanOne : hasMoreThanOne,
					isPhoneDevice : Utils.isPhoneDevice(),
					currentPage : currentPage+"/cart",
					/*itemHasNoAvailableQuantity : itemHasNoAvailableQuantity,
					blockMiniCartToCheckout : blockMiniCartToCheckout,
					strykerUSRestriction : strykerUSRestriction*/
				})

				//console.log(result);

				return result;
		     });

       			layout.addToViewEventsDefinition(
				'Header.View',
				'click [data-action="custom-signout"]',
				function (e) 
				{
					e.stopPropagation();
					e.preventDefault();
					//Cookies.set('UserList' ,"");
			       // Cookies.set('ProductListItems',"");
					window.location.href = SC.SESSION.touchpoints.logout;
				});

				layout.addToViewContextDefinition('Footer.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      });

				layout.addToViewContextDefinition('Footer.View', 'allowAutomaticPopup', 'boolean', function(context) {
				           var profileModel = context.profileModel
				            ,   profile_custom_fields = profileModel.customfields
				            ,   mcOptIn = _.findWhere(profile_custom_fields, {name: "custentity_mc_opt_in"})
							
							//console.log(mcOptIn.value)				        			            

				            return (mcOptIn.value == "F" ? true : false)
				});

				/*layout.addToViewContextDefinition('Footer.View', 'isLoggedIn', 'boolean', function(context) {
			            return (profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F');
			      });*/

				 layout.addToViewContextDefinition('Footer.View', 'isLoggedIn', 'boolean', function(context) {
				           // console.log(context.profileModel.isLoggedIn)
				            return (context.profileModel.isLoggedIn == "T" ? true : false)
				});

				layout.addToViewEventsDefinition(
				'Footer.View',
				'click [data-action="take-to-login-first-footer"]',
				function (e) 
				{
					let login = Session.get('touchpoints.login');

		            login += '&origin=' + Configuration.currentTouchpoint;

		            login += '&origin_hash=inventory-list';
		            window.location.href = login;
				})    

			
				layout.addToViewContextDefinition('Header.Menu.View', 'isPhoneDevice', 'boolean', function(context) {
				            return Utils.isPhoneDevice();
				      });

				layout.addToViewContextDefinition('Header.Menu.View', 'categories', 'array', function(context) {
					var categories = context.categories;
					if (!categories || !categories.length) return categories;

					var desiredOrder = ['Categories', 'Manufacturers', 'AA Certified', 'AA Refurbished', 'Scope Repair', 'Inventory Lists', 'Subscribe', 'Deals'];
					var sorted = [];

					_.each(desiredOrder, function(name) {
						var found = _.find(categories, function(cat) { return cat.text === name; });
						if (found) sorted.push(found);
					});

					_.each(categories, function(cat) {
						if (desiredOrder.indexOf(cat.text) === -1) sorted.push(cat);
					});

					return sorted;
				});


				layout.addToViewContextDefinition('Header.View', 'isTabletDevice', 'boolean', function(context) {
			            
			            var window_width = jQuery(window).width();
			            var tablet_large = false;
			            //console.log(window_width)
			            if(window_width <= 992 || window_width >= 1024)
			            	tablet_large = true;

			            return tablet_large;
			      });

			FacetsItemCellView.prototype.getContext = _.wrap(FacetsItemCellView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);		

			var itemQtyInCurrentOrder = 0;

				var lightboxItem = this.model.get('custitem_lightbox_item_url_component');
				var finalLightboxUrl = ''
				,   kititemonly = this.model.get('custitem_kit_item_only') 
				,   qtyAvailableInv = this.model.get('custitem_qty_available_inv')
				,   qtyAvailableKit = this.model.get('custitem_qty_available_kit')
				,   itemType = this.model.get('itemtype')
				,   enableOutOfStock = this.model.get('custitem_celigo_shopify_enable_out_sto')
				,   isWebsiteCategoryProduct = this.model.get('custitem157') 
				,   isKitItemOnly = this.model.get('custitem_kit_item_only') 
				,   outOfStockDisplay = this.model.get('custitem_aa_out_of_stock_display')
				,   serialLotFunctionality = this.model.get('custitem_pdp_seriallot_number_function')
	            ,   serialLotMinPrice = this.model.get('custitem_icm_ain_min_price')
	            ,   serialLotMaxPrice = this.model.get('custitem_icm_ain_max_price')
	            ,   showOutOfStockButton = false
	            ,   showContactForPricingButton = false
				,   showOutofStock = false;


				var serial_number_page = this.model.get('custitem_aams_serial_number_page')
	            ,   serial_number_price_range = this.model.get('custitem_serial_number_price_range_web')

			if(qtyAvailableInv == undefined)
				qtyAvailableInv = 0;

			if(qtyAvailableKit == undefined)
				qtyAvailableKit = 0;
			
			if(lightboxItem !== '' /*&& kititemonly == true*/)
			{
				finalLightboxUrl = "/"+lightboxItem;
			}

			//console.log(isWebsiteCategoryProduct)


			if(itemType == "Kit")
			{
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableKit <= 0 && enableOutOfStock == false)
				{
					showOutofStock = true;

					if(outOfStockDisplay == "Out of Stock")
	                showOutOfStockButton = true;
	            	else if(outOfStockDisplay == "Contact for Pricing")
	                showContactForPricingButton = true;
				}
			}
			else if(itemType == 'InvtPart' || itemType == 'Assembly')
			{
				//Item Qty is 0 and Allow out of stock checkbox is not checked
				if(qtyAvailableInv <= 0 && enableOutOfStock == false)
				{
					showOutofStock = true;

					if(outOfStockDisplay == "Out of Stock")
	                showOutOfStockButton = true;
	            	else if(outOfStockDisplay == "Contact for Pricing")
	                showContactForPricingButton = true;
				}
			}

			//console.log(qtyAvailableInv)

			var price_detail = this.model.get('onlinecustomerprice_detail');
			var relateditems_detail=_.sortBy(this.model.get('relateditems_detail'), 'custitem_aamedical_sca_sub_category'); 	
            var subCategoriesList = _.compact(_.uniq(_.pluck(relateditems_detail , 'custitem_aamedical_sca_sub_category'))); 
            
            if(subCategoriesList.length > 0)
			subCategoriesList = (subCategoriesList.join()).replaceAll(','," • ")	

			var price_container_object = this.model.getPrice()
			,   pricelevel1 = this.model.get('pricelevel1')
			,   pricelevel1_formatted = this.model.get('pricelevel1_formatted')
			,   onlinecustomerprice_detail = price_detail
			,   applyStrikeThroughPrice = false
			,   onlineprice = onlinecustomerprice_detail.onlinecustomerprice
			,   pricelevel5 = onlinecustomerprice_detail.onlinecustomerprice
			,   special_formatted_pricelevel1 = ''
			,   special_formatted_pricelevel5 = ''
			,	savePrice = 0
			,	savePercent=0
			,	discountPercentage=0;

			//console.log(this.model)

			if(pricelevel1 && pricelevel1 > onlineprice)
			{
				//console.log(pricelevel1.toLocaleString('en'));
				applyStrikeThroughPrice = true;
			}

			if(pricelevel1_formatted)
				special_formatted_pricelevel1 = pricelevel1_formatted.substr(0, pricelevel1_formatted.indexOf('.'));
			
			if(price_container_object)
			{
				onlineprice = price_container_object.price_formatted;
				//console.log(price_container_object)
				if(onlineprice)
				special_formatted_pricelevel5 = onlineprice.substr(0, onlineprice.indexOf('.'));
				
				var currPrice = pricelevel5 || pricelevel1 || 0; 
				if( currPrice < 5){
				    showOutofStock = true;
				}
			}	
				//console.log(this.model.getPrice())
			//using lightbox field condition instead of relateditems
			//if(subCategoriesList.length  == 0)
			if(lightboxItem == '')
			{

				var liveOrder = LiveOrderModel.getInstance();
				var self = this;
				
				var lineData=liveOrder.get('lines').filter(function(line)
				{	
					return line.get('item').get('internalid') == self.model.get('_id');
		       	});

		       	if(lineData.length > 0)
		       	{
		       	var lineQuantity=lineData[0].get('quantity');
		       	itemQtyInCurrentOrder = lineQuantity;
		       	}
		       //	console.log(itemQtyInCurrentOrder)
			}

			var url = '';
			if(ProfileModel.getInstance().hidePrices())
			{
				 url = Session.get('touchpoints.login') +
                '&origin=' +
                (Configuration.get('currentTouchpoint') || 'home') +
                '&origin_hash=';

                url = url +
                encodeURIComponent(this.options.origin === 'PDPQUICK'
                    ? this.model.generateURL().replace('/', '')
                    : Backbone.history.fragment);
			}

				/*if(isKitItemOnly == true)
	                showOutofStock = true;*/
	            
	            if(applyStrikeThroughPrice)
	            {
	            	savePrice = parseFloat((Number(pricelevel1) - Number(pricelevel5)).toFixed(2));
	            	discountPercentage = (savePrice / pricelevel1) * 100;
	            	savePercent=Math.trunc(discountPercentage)+ "%";
	            }
				_.extend(result, {
								isPhoneDevice: Utils.isPhoneDevice(),
								plpPrice : price_detail.onlinecustomerprice_formatted,
								subCategoriesList : subCategoriesList.length > 0,
								itemQtyInCurrentOrder : itemQtyInCurrentOrder,
					            itemQtyInCurrentOrderCheck : itemQtyInCurrentOrder > 0,
					            itemQtyInCurrentOrderCheck2 : itemQtyInCurrentOrder < 1,
					            origin: 'PLP',
					            lightBoxItemURL : finalLightboxUrl,
					            applyStrikeThroughPrice : applyStrikeThroughPrice,
								BasePriceFormatted : special_formatted_pricelevel1,
								OnlinePriceFormatted : special_formatted_pricelevel5,
								showOutofStock : showOutofStock,
								isWebsiteCategoryProduct : isWebsiteCategoryProduct,
								hidePricing: ProfileModel.getInstance().hidePrices(),
								urlLogin: url,
								savePrice : savePrice,
								savePercent:savePercent,
								showContactForPricingButton : showContactForPricingButton,
	            				showOutOfStockButton : showOutOfStockButton,
	            				serialLotFunctionality : serialLotFunctionality,
	            				serialLotMinPrice: Utils.formatCurrency(serialLotMinPrice),
	            				serialLotMaxPrice: Utils.formatCurrency(serialLotMaxPrice),
	            				hasSerialMinMax: (serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== ''),
	            				hasSerialMinOnly: (serialLotMinPrice != null && serialLotMinPrice !== '') && !(serialLotMaxPrice != null && serialLotMaxPrice !== ''),
	            				hasSerialMaxOnly: !(serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== ''),
	            				serialMinMaxEqual: (serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== '') && parseFloat(serialLotMinPrice) === parseFloat(serialLotMaxPrice)
							});
				//console.log(result);
				return result;
			})	

			layout.addChildView('HomePage-NewArrivals', function () {
				//console.log(layout)
			  var windowWidth = jQuery(window).width()
			  ,   maxSlides = 3
			  ,   slideWidth = 193
			  //console.log(windowWidth)

			  if(windowWidth >= 992 && windowWidth <= 1098)
			  {
			  	maxSlides = 2
			  	slideWidth = 195
			  }
			  else if(windowWidth >= 1100 && windowWidth <= 1350){
			  	if(windowWidth <= 1200)
			  	{
			  		maxSlides = 3
			  		slideWidth = 150
			  	}else{
			  		maxSlides = 3
			  		slideWidth = 170
			  	}			  	
			  }
			  else if(windowWidth >= 760 && windowWidth <= 991)
			  {
			  	if(windowWidth >= 850)
			  	{
			  		maxSlides = 3
			  		slideWidth = 235
			  	}
			  	else{
			  		maxSlides = 3
			  		slideWidth = 205
			  		}
			  }

			  var savedsearchConfiguration = Configuration.SavedSearchNewArrivals
			  ,   savedsearchConfigurationConfig = savedsearchConfiguration.config
			  //console.log(savedsearchConfigurationConfig);

			  return new NewArrivalsHomeView({
				  	application : layout.application,
				  	container : container,
				  	slideWidth : slideWidth,
				  	maxSlides : maxSlides,
				  	savedsearchid: savedsearchConfigurationConfig,
				  	origin : 'newarrivals',
				  	configuration : Configuration
				  });

			  /*return new CarouselView({
				  	application : layout.application,
				  	container : container,
				  	slideWidth : slideWidth,
				  	maxSlides : maxSlides,
				  	savedsearchid: savedsearchConfigurationConfig,
				  	origin : 'newarrivals',
				  	configuration : Configuration
				  });*/
			});

			layout.addChildView('HomePage-MostPopular', function () {
				//console.log(layout)
			var windowWidth = jQuery(window).width()
			,   maxSlides = 4
			,   slideWidth = 300

			  if(windowWidth >= 992 && windowWidth <= 1098)
			  {
			  	maxSlides = 3
			  	slideWidth = 293
			  }
			  else if(windowWidth >= 1100 && windowWidth <= 1350){
			  	if(windowWidth <= 1200)
			  	{
			  		maxSlides = 4
			  		slideWidth = 230
			  	}
			  	else
			  	{
			  		maxSlides = 4
			  		slideWidth = 255
			  	}		  	
			  }
			   else if(windowWidth >= 760 && windowWidth <= 991)
			  {
			  	//console.log(windowWidth)
			  	if(windowWidth >= 850)
			  	{
			  		maxSlides = 3
			  		slideWidth = 230
			  	}
			  	else
			  	{
			  		maxSlides = 3
			  		slideWidth = 210
			  	}
			  		
			  }

			  var savedsearchConfiguration = Configuration.SavedSearchMostPopular
			  ,   savedsearchConfigurationConfig = savedsearchConfiguration.config
			  //console.log(layout);

			  return new CarouselView({
				  	application : layout.application,
				  	container : container,
				  	slideWidth : slideWidth,
				  	maxSlides : maxSlides,
				  	savedsearchid: savedsearchConfigurationConfig,
				  	origin : 'mostpopular',
				  	configuration : Configuration
				  });
			});


			layout.addToViewEventsDefinition(
			  'Cart.Confirmation.View',
			  'click [data-action="take-to-cart"]',
			  function(e) {
			  	//console.log(e)
			  	//var href= $(location).attr('href')+"/cart"
			  	window.location.href = Utils.addParamsToUrl(Session.get('touchpoints.home'), {
                    fragment: '/cart'
                	});
			  }
			);

				layout.addChildView('Header.MiniCart1', function () {
				   //console.log(layout)
				  return new HeaderMiniCartView({
				  });
				});

				layout.addToViewEventsDefinition(
				  'Header.MiniCart.View',
				  'click [data-action="take-to-cart"]',
				  function(e) {
				  	//console.log(e)
				  	//var href= $(location).attr('href')+"/cart"
				  	window.location.href = Utils.addParamsToUrl(Session.get('touchpoints.home'), {
	                    fragment: '/cart'
	                	});
				  }
				);

				layout.addToViewEventsDefinition(
			  'Header.Menu.View',
			  'click [data-action="categories-menu"]',
			  function(e) {
			  	if (!(Utils.isPhoneDevice() || Utils.isTabletDevice())) return;

			  	const anchor = jQuery(e.currentTarget);

		        const parent_li = anchor.closest('li');

		        $('.extra-level-container').empty();

		        if(parent_li.hasClass('open'))
		        {
		        jQuery('#main').removeClass('nav-opened');
		        parent_li.removeClass('open')
		        $('.header-menu-level2').find('li').removeClass("open");
		        }
		        else
		        {
			        var siblings = parent_li.siblings()

			        if(siblings.hasClass('open'))
			        siblings.removeClass('open')

			        parent_li.addClass('open');
			        jQuery('#main').addClass('nav-opened');

			         $('.header-menu-level2').find('li').removeClass("open");
			         $('.manufacturer-header-menu-level2').find('li').removeClass("opened");
			         $('.manufacturer-level3').css('display','none');
		        }
			  }
			);


			layout.addToViewEventsDefinition(
			  'Header.Menu.View',
			  'click [data-action="manufacturers-menu-level2"]',
			  function(e) {
			  	if (!(Utils.isPhoneDevice() || Utils.isTabletDevice())) return;

			  	const anchor = jQuery(e.currentTarget);

		        const parent_li = anchor.closest('li');
		       // var parents_parent = parent_li.parent()
		        
		       // console.log(parent_li)

		        var siblings = parent_li.siblings();
		        if(siblings.hasClass('opened'))
					{
						var siblings_children = siblings.children('ul.subcategories')
							/*,   siblings_children_child = siblings_children.children('li.opened') 
							console.log(siblings_children)
							if(siblings_children_child.length > 0)
							{
								console.log('omsode')
								siblings_children_child.removeClass('opened')
								siblings_children_child.children('ul.subcategories').css('display','none');
							}	*/
							siblings.removeClass('opened')
							siblings.children('ul.subcategories').css('display','none');
							//$('.manufacturer-header-menu-level2 .has-subcategories').removeClass('opened')
							//$('.manufacturer-level3 .has-subcategories').removeClass('open')
					}

				 if(parent_li.hasClass('opened'))
				 {
				 	parent_li.removeClass('opened')
				 }	
				 else
				 {
				 	parent_li.addClass('opened');
				 	$('.manufacturer-level3 .has-subcategories').removeClass('open')
				 }

				 if(parent_li.hasClass('has-subcategories'))
		  		{
		  			//donothing
		  			//console.log('inin')
		  		}
		  		else{
		  			var flag = $('.header-menu-level1').children().hasClass('open');
		  			//console.log(flag)
				  	if(flag)
				  	{
				  		$('.header-menu-level1').find('li').removeClass("open");
				  		jQuery('#main').removeClass('nav-opened');
				  	}
		  		}
				 /*if(siblings.children('ul.subcategories').css('display') == 'none')
						{
							console.log('yes if')
							//if(!parent_li.hasClass('opened'))
							parent_li.addClass('opened')
							$('.manufacturer-level3 .has-subcategories').removeClass('open')
						}
						else
						{
							console.log('yes else')
							var parent_children = parent_li.children('ul.subcategories')
							,   parent_children_child = parent_children.children('li.opened')

							if(parent_children_child.length > 0)
							{
								parent_children_child.removeClass('opened')
								parent_children_child.children('ul.subcategories').css('display','none');
								//parent_children_child.children('ul.subcategories .has-subcategories').removeClass('open')
							}	
							parent_li.removeClass('opened')
							//parent.children('ul.subcategories').css('display','none');
						}*/
						

						var find_ul = parent_li.find(".subcategories").first();
						$(find_ul).slideToggle(200)	

			  }
			);


			layout.addToViewEventsDefinition(
			  'Header.Menu.View',
			  'click [data-action="manufacturers-menu-level3"]',
			  function(e) {
			  	e.stopPropagation();
			  	e.preventDefault();
			  	if (!(Utils.isPhoneDevice() || Utils.isTabletDevice())) return;

			  	var element = jQuery(e.currentTarget);
			  	var data_attr = element.attr('data-href')
			  	var parent = element.parent();
			  	var parent_attr = parent.attr('data-href')
			  	var parents_parent = parent.parent()
			  	var parents_parent_attr = parents_parent.attr('data-href')

			  	var pointTarget = e.target;
				var targetedLink = jQuery(pointTarget);
				var categoryWiseItemsObject = JSON.parse(localStorage.getItem('CategoryWiseItemsCount'))

				if(jQuery(pointTarget).hasClass('take-to-that-page'))
				{
					var href = targetedLink.attr('href');
			  		var touchPoint = targetedLink.attr('touchpoint')

			  		if(touchPoint == 'home')
			  		{
			  			Backbone.history.navigate(href, {
		                    trigger: true
		                });
		                var flag = $('.header-menu-level1').children().hasClass('open');
					  	if(flag)
					  	{
					  		$('.header-menu-level1').find('li').removeClass("open");
					  		jQuery('#main').removeClass('nav-opened');
					  	}
					  	if($('.manufacturer-header-menu-level2 .has-subcategories').hasClass('opened'))
					  	{
					  		$('.manufacturer-header-menu-level2 .has-subcategories').removeClass('opened')
					  		$('.manufacturer-level3').css('display','none')
					  	}
			  		}
			  		else
               		{
	                	window.location.href = Utils.addParamsToUrl(Session.get('touchpoints.home'), {
	                    fragment: href
	                	});
                	}
				}
				else if(jQuery(pointTarget).hasClass('show-more-less'))
			  	{
			  		const par = targetedLink.parent()
			  		var targetFound = targetedLink.attr('data-target');

			  		const target_see_more = par.find('[data-type="see-more"]');
			        const target_see_less = par.find('[data-type="see-less"]');
			        const target_was_expanded = !!par.data('collapsed');

			        const find_right_sibling = par.parent().siblings('.extra-values')

			        if (target_was_expanded) {
			            target_see_more.show();
			            find_right_sibling.collapse('hide')
			            target_see_less.hide();
			        } else {
			        	find_right_sibling.collapse('show')
			            target_see_more.hide();
			            target_see_less.show();
			        }

			        par.data('collapsed', !target_was_expanded);
			  	}
			  	else
			  	{


				  	var nav_data = Configuration.navigationData
				  	,   all_level2_categories = []
				  	//console.log(data_attr);
				  	//console.log(parents_parent_attr);


				  	_.each(nav_data, function(nav) {
				  		var categories = nav.categories;
				  		if(categories && categories.length > 0)
				  			all_level2_categories = all_level2_categories.concat(categories);
					});

				  	var find_secondlevel_menu = _.findWhere(all_level2_categories, {
	                    href: parents_parent_attr
	                });


				  	//if Level2 is opened, then close existing one and open current clicked one
				  	if(jQuery('.manufacturer-level3 li.has-subcategories').hasClass('open'))
				  	{
				  		jQuery('.manufacturer-level3 li.has-subcategories').removeClass('open');
				  		jQuery(e.currentTarget).addClass('open');			  		
				  	}
				  	else 
				  	{
				  		jQuery(e.currentTarget).addClass('open');
				  	}	  	

				  	var find_thirdlevel_menu_category = find_secondlevel_menu.categories;

				  	var find_thirdlevel_menu = _.findWhere(find_thirdlevel_menu_category, {
	                    href: data_attr
	                });

              	 // console.log(find_thirdlevel_menu)

				  	if(find_thirdlevel_menu.categories && find_thirdlevel_menu.categories.length > 0)
				  	{
				  		//console.log(find_thirdlevel_menu)
				  		e.stopPropagation();
				  		e.preventDefault();

		                
		                var find_category_text = find_thirdlevel_menu.text
					  	,   find_category_href = find_thirdlevel_menu.href

					  	,   find_length = find_thirdlevel_menu.categories

		                ,   find_category_cat = find_thirdlevel_menu.categories
		                ,   column1_values = []
		               // ,   column2_values = []
		                ,   max = 3


		                var geArrChunks = HeaderViewExt.geArrChunks(find_category_cat, 4);
		               	//console.log(geArrChunks)

		               	column1_values = geArrChunks;

					  	var appendDiv = '';
					  	//var self = this;

					  	var currentTouchpoint = Configuration.get('currentTouchpoint')
					  	//console.log(currentTouchpoint)

					  	//console.log(column1_values)
					  	//console.log(column1_values.length)
					  	if(column1_values.length > 0)
					  	{			  	
					  	appendDiv += "<div class='all'><a class='take-to-that-page' touchpoint="+currentTouchpoint+" data-action='take-action' data-hashtag='#"+find_category_href+"' data-touchpoint='home' href="+find_category_href+">All "+find_category_text+"</a></div>";
					  	appendDiv += "<div class='appender'>";
					  				  
					  	_.each(column1_values, function(level3) {
					  			//console.log(level3)
					  		//var ul_width = (100/level3.length)+120;
					  		var ul_width = 167;
					  		//console.log(level3)
					  		appendDiv += "<ul class='column1'>"
						  		_.each(level3, function(level3data,index) {
						  			var level3_categories = level3data.categories
						  			var hasLevel5 = level3_categories && level3_categories.length > 0;

						  			if(hasLevel5) {
						  				appendDiv += "<li class='level3 has-subcategories' data-action='manufacturers-menu-level4' data-href='"+level3data.href+"'>";
						  				appendDiv += "<a class='manufacturers-menu-level4-anchor'>"+level3data.text+"<i class='header-menu-chevron-icon'></i></a>";
						  				appendDiv += "<ul class='manufacturer-level5' style='display:none'>";
						  				appendDiv += "<li class='level4'><a class='take-to-that-page' touchpoint="+currentTouchpoint+" data-action='take-action' data-hashtag='#"+level3data.href+"' data-touchpoint='home' href="+level3data.href+">All "+level3data.text+"</a></li>";
						  				_.each(level3_categories, function(level5item) {
						  					var level5CatItemCountObject = _.find(categoryWiseItemsObject, function(item) {
						  						return item.categoryId === level5item.additionalFields.internalid;
						  					}) || {};
						  					var level5CatItemCount = (level5CatItemCountObject && level5CatItemCountObject.itemCount != null)
						  						? " [" + level5CatItemCountObject.itemCount + "]"
						  						: "";
						  					appendDiv += "<li class='level4'><a class='take-to-that-page' touchpoint="+currentTouchpoint+" data-action='take-action' data-hashtag='#"+level5item.href+"' data-touchpoint='home' href="+level5item.href+">"+level5item.text+level5CatItemCount+"</a></li>";
						  				})
						  				appendDiv += "</ul>";
						  			} else {
						  				appendDiv += "<li class='level3'>";
						  				appendDiv += "<a class='take-to-that-page' touchpoint="+currentTouchpoint+" data-action='take-action' data-hashtag='#"+level3data.href+"' data-touchpoint='home' href="+level3data.href+">"+level3data.text+"</a>";
						  			}
					  				appendDiv += "</li>"
						  		})

					  		appendDiv += "</ul>"
					  	});

					  	appendDiv += "</div>"

					  	$('.extra-level-container').html(appendDiv)

				  	 }
				  	}
			  	   //if Level2 has no subcategories, then hide whole nav when its clicked
				  	if(jQuery(e.currentTarget).hasClass('has-subcategories'))
			  		{
			  			//donothing
			  			//console.log('donothing')
			  		}
			  		else{
			  			//console.log(parent)
			  			//console.log(parents_parent)
			  			parent.css('display','none')
			  			parents_parent.removeClass("opened");
			  			//$('.manufacturer-header-menu-level2 .has-subcategories').removeClass('opened');
			  			//$('.manufacturer-level3').css('display','none');

			  			var flag = $('.header-menu-level1').children().hasClass('open');
					  	if(flag)
					  	{
					  		$('.header-menu-level1').find('li').removeClass("open");
					  		jQuery('#main').removeClass('nav-opened');
					  	}
			  			//$('.header-menu-level1').find('li').removeClass("open");	
			  		}       
			  	}	
			  }
			);

			// Manufacturer Level 4 click handler (mobile) — expand/collapse Level 5 accordion
			layout.addToViewEventsDefinition(
			  'Header.Menu.View',
			  'click [data-action="manufacturers-menu-level4"]',
			  function(e) {
			  	e.stopPropagation();
			  	e.preventDefault();
			  	if (!(Utils.isPhoneDevice() || Utils.isTabletDevice())) return;

			  	var pointTarget = jQuery(e.target);

			  	// If a take-to-that-page link was clicked, navigate
			  	if(pointTarget.hasClass('take-to-that-page') || pointTarget.closest('.take-to-that-page').length) {
			  		var targetedLink = pointTarget.hasClass('take-to-that-page') ? pointTarget : pointTarget.closest('.take-to-that-page');
			  		var href = targetedLink.attr('href');
			  		var touchPoint = targetedLink.attr('touchpoint');

			  		if(touchPoint == 'home') {
			  			Backbone.history.navigate(href, { trigger: true });
			  		} else {
			  			window.location.href = Utils.addParamsToUrl(Session.get('touchpoints.home'), { fragment: href });
			  		}
			  		// Close entire nav
			  		$('.header-menu-level1').find('li').removeClass("open");
			  		jQuery('#main').removeClass('nav-opened');
			  		$('.manufacturer-header-menu-level2 .has-subcategories').removeClass('opened');
			  		$('.manufacturer-level3').css('display','none');
			  		return;
			  	}

			  	// Toggle Level 5 accordion
			  	var element = jQuery(e.currentTarget);

			  	// Close sibling Level 4 accordions
			  	element.siblings('.has-subcategories.open').each(function() {
			  		jQuery(this).removeClass('open');
			  		jQuery(this).children('.manufacturer-level5').slideUp(200);
			  	});

			  	// Toggle current
			  	if(element.hasClass('open')) {
			  		element.removeClass('open');
			  		element.children('.manufacturer-level5').slideUp(200);
			  	} else {
			  		element.addClass('open');
			  		element.children('.manufacturer-level5').slideDown(200);
			  	}
			  }
			);

			/*layout.addToViewEventsDefinition(
			  'Header.Menu.View',
			  'click [data-action="hide-categories-nav"]',
			  function(e) {
			  	const anchor = jQuery(e.currentTarget);
			  	var flag = $('.header-menu-level1').children().hasClass('open');
			  	if(flag)
			  	{
			  		$('.header-menu-level1').find('li').removeClass("open");
			  		jQuery('#main').removeClass('nav-opened');
			  	}
			  }
			);*/

			//Not using it anymore as everything in 1 event methond 'click [data-action="categories-menu-level2"]'
			/*layout.addToViewEventsDefinition(
			  'Header.Menu.View',
			  'click [data-action="take-action"]',
			  function(e) {
			  	e.stopPropagation();
			  	e.preventDefault();

			  	const anchor = jQuery(e.currentTarget);
			  	const href = anchor.attr('href');
			  	const touchPoint = anchor.attr('touchpoint')
			  	//console.log(href)

			  	if(touchPoint)
			  	{
				  	Backbone.history.navigate(href, {
	                    trigger: true
	                });

	                var flag = $('.header-menu-level1').children().hasClass('open');
				  	if(flag)
				  	{
				  		$('.header-menu-level1').find('li').removeClass("open");
				  		jQuery('#main').removeClass('nav-opened');
				  	}
				  	if($('.manufacturer-header-menu-level2 .has-subcategories').hasClass('opened'))
				  	{
				  		$('.manufacturer-header-menu-level2 .has-subcategories').removeClass('opened')
				  		$('.manufacturer-level3').css('display','none')
				  	}
                }
                else
                {
                	window.location.href = Utils.addParamsToUrl(Session.get('touchpoints.home'), {
                    fragment: href
                	});
                }
			  }
			);*/

			//Not using it anymore as everything in 1 event methond 'click [data-action="categories-menu-level2"]'
			/*layout.addToViewEventsDefinition(
			  'Header.Menu.View',
			  'click [data-action="see-more-list"]',
			  function(e) {
			  	e.stopPropagation();
			  	e.preventDefault();

			  	const target = jQuery(e.currentTarget);
		        const target_see_more = target.find('[data-type="see-more"]');
		        const target_see_less = target.find('[data-type="see-less"]');
		        const target_was_expanded = !!target.data('collapsed');

		        const find_right_sibling = target.parent().siblings('.extra-values')
		        
		        if (target_was_expanded) {
		            target_see_more.show();
		            find_right_sibling.collapse('hide')
		            target_see_less.hide();
		        } else {
		        	find_right_sibling.collapse('show')
		            target_see_more.hide();
		            target_see_less.show();
		        }

		        target.data('collapsed', !target_was_expanded);
			  }
			);  */

			layout.addToViewEventsDefinition(
			  'Header.Menu.View',
			  'click [data-action="categories-menu-level2"]',
			  function(e) {
			  	e.preventDefault();
				e.stopPropagation();

				// Desktop uses hover for subcategory expansion; only allow click for link navigation
				var pointTarget = e.target;
				var targetedLink = jQuery(pointTarget);
				if (!(Utils.isPhoneDevice() || Utils.isTabletDevice())) {
					// On desktop, only handle take-to-that-page link clicks
					if(jQuery(pointTarget).hasClass('take-to-that-page')) {
						var href = targetedLink.attr('href');
						if(Configuration.get('currentTouchpoint') == 'home') {
							Backbone.history.navigate(href, { trigger: true });
							jQuery('.header-menu-level1 > li').removeClass('hover-open');
							jQuery('#main').removeClass('nav-opened');
						} else {
							window.location.href = Utils.addParamsToUrl(Session.get('touchpoints.home'), { fragment: href });
						}
					}
					return;
				}

			  	var element = jQuery(e.currentTarget);
			  	var data_attr = element.attr('data-href')

			  	var categoryWiseItemsObject = JSON.parse(localStorage.getItem('CategoryWiseItemsCount'))

			  	if(jQuery(pointTarget).hasClass('take-to-that-page'))
			  	{		
			  		var href = targetedLink.attr('href');
			  		var touchPoint = targetedLink.attr('touchpoint')
			  		var dataTouchPoint = targetedLink.attr('data-touchpoint')

			  		//console.log(Configuration.get('currentTouchpoint'))

			  		if(Configuration.get('currentTouchpoint') == 'home')
			  		{
			  			Backbone.history.navigate(href, {
		                    trigger: true
		                });
		                var flag = $('.header-menu-level1').children().hasClass('open');
					  	if(flag)
					  	{
					  		$('.header-menu-level1').find('li').removeClass("open");
					  		jQuery('#main').removeClass('nav-opened');
					  	}
					  	if($('.manufacturer-header-menu-level2 .has-subcategories').hasClass('opened'))
					  	{
					  		$('.manufacturer-header-menu-level2 .has-subcategories').removeClass('opened')
					  		$('.manufacturer-level3').css('display','none')
					  	}
			  		}
			  		else
               		{
	                	window.location.href = Utils.addParamsToUrl(Session.get('touchpoints.home'), {
	                    fragment: href
	                	});
                	}
			  	}
			  	else if(jQuery(pointTarget).hasClass('show-more-less'))
			  	{
			  		const par = targetedLink.parent()
			  		var targetFound = targetedLink.attr('data-target');

			  		const target_see_more = par.find('[data-type="see-more"]');
			        const target_see_less = par.find('[data-type="see-less"]');
			        const target_was_expanded = !!par.data('collapsed');

			        const find_right_sibling = par.parent().siblings('.extra-values')

			        if (target_was_expanded) {
			            target_see_more.show();
			            find_right_sibling.collapse('hide')
			            target_see_less.hide();
			        } else {
			        	find_right_sibling.collapse('show')
			            target_see_more.hide();
			            target_see_less.show();
			        }

			        par.data('collapsed', !target_was_expanded);
			  	}
			  	else
			  	{
			  	
				  	//$('.extra-level-container').css('display','block');

				  	var nav_data = Configuration.navigationData
				  	,   all_level2_categories = []
				  	//console.log(nav_data);

				  	_.each(nav_data, function(nav) {
				  		var categories = nav.categories;
				  		if(categories && categories.length > 0)
				  			all_level2_categories = all_level2_categories.concat(categories);
					});

				  	//console.log(all_level2_categories)
				

				  	//if Level2 is opened, then close existing one and open current clicked one
				  	if(jQuery('.header-menu-level2 li.has-subcategories').hasClass('open'))
				  	{
				  		jQuery('.header-menu-level2 li.has-subcategories').removeClass('open');
				  		jQuery(e.currentTarget).addClass('open');			  		
				  	}
				  	else 
				  	{
				  		jQuery(e.currentTarget).addClass('open');
				  	}


				  	var find_category = _.findWhere(all_level2_categories, {
	                    href: data_attr
	                });

			  	

				  	if(find_category.categories)
				  	{
		                
		                var find_category_text = find_category.text
					  	,   find_category_href = find_category.href

					  	,   find_length = find_category.categories

		                ,   find_category_cat = find_category.categories
		                ,   column1_values = []
		               // ,   column2_values = []
		                ,   max = 3


		                var geArrChunks = HeaderViewExt.geArrChunks(find_category_cat, 4);
		               //	console.log(geArrChunks)

		               	column1_values = geArrChunks;

					  	var appendDiv = '';
					  	//var self = this;

					  	var currentTouchpoint = Configuration.get('currentTouchpoint')
					  	//console.log(currentTouchpoint)

					  	//console.log(column1_values)
					  	//console.log(column1_values.length)
					  	if(column1_values.length > 0)
					  	{			  	
					  	appendDiv += "<div class='all'><a class='take-to-that-page' touchpoint="+currentTouchpoint+" data-action='take-action' data-hashtag='#"+find_category_href+"' data-touchpoint='home' href="+find_category_href+">All "+find_category_text+"</a></div>";
					  	appendDiv += "<div class='appender'>";
					  				  
					  	_.each(column1_values, function(level3) {
					  			//console.log(level3)
					  		//var ul_width = (100/level3.length)+120;
					  		var ul_width = 201;
					  		//console.log(level3)
					  		appendDiv += "<ul class='column1' style='width:"+ul_width+"px'>"					  		
						  		_.each(level3, function(level3data,index) {
						  			var level3_categories = level3data.categories
							  		var display_values = _.first(level3_categories, 5);
							  		//console.log(display_values)
							  		var extra_values = _.rest(level3_categories, 5);
							  		//console.log(extra_values)

							  		var level3text = level3data.href
							  		,   apply_extra_belly = false
							  		,   apply_extra_belly_level3 = false

							  		if(display_values.length > 0)
							  			apply_extra_belly_level3 = true;

							  		if(extra_values.length > 0)
							  			apply_extra_belly = true;

							  		appendDiv += "<li class='level3 "+apply_extra_belly_level3+"'><a class='take-to-that-page' touchpoint="+currentTouchpoint+" data-action='take-action' data-hashtag='#"+level3data.href+"' data-touchpoint='home' href="+level3data.href+">"+level3data.text+"</a>";
					  				if(level3_categories){
					  					appendDiv += "<ul class='lev-4 display-values "+apply_extra_belly+"'>";
					  					_.each(display_values, function(level4displayvalues) {
							  				var level4displayvaluesCatItemCountObject= _.find(categoryWiseItemsObject, function(item) {
											  return item.categoryId === level4displayvalues.additionalFields.internalid;
											})|| {};
											
											var level4displayvaluesCatItemCount = (level4displayvaluesCatItemCountObject && level4displayvaluesCatItemCountObject.itemCount != null)
											  ? " (" + level4displayvaluesCatItemCountObject.itemCount + ")"
											  : "";
							  				appendDiv += "<li class='level4'><a touchpoint="+currentTouchpoint+" class='take-to-that-page' data-action='take-action' data-hashtag='#"+level4displayvalues.href+"' data-touchpoint='home' href="+level4displayvalues.href+">"+level4displayvalues.text + level4displayvaluesCatItemCount + "</a></li>";
							  			})
							  			appendDiv += "</ul>";

							  			if(extra_values.length > 0)
					  					{	
					  						appendDiv += "<ul class='lev-4 extra-values collapse' id='"+level3text+"'>";
							  				_.each(extra_values, function(level4extravalues) {
								  				var level4extravaluesCatItemCountObject= _.find(categoryWiseItemsObject, function(item) {
												  return item.categoryId === level4extravalues.additionalFields.internalid;
												})|| {};
												
												var level4extravaluesCatItemCount = (level4extravaluesCatItemCountObject && level4extravaluesCatItemCountObject.itemCount != null)
												  ? " (" + level4extravaluesCatItemCountObject.itemCount + ")"
												  : "";
								  				appendDiv += "<li class='level4'><a touchpoint="+currentTouchpoint+" class='take-to-that-page' data-action='take-action' data-hashtag='#"+level4extravalues.href+"' data-touchpoint='home' href="+level4extravalues.href+">"+level4extravalues.text + level4extravaluesCatItemCount +"</a></li>";
								  			})
								  			appendDiv += "</ul>";
								  			appendDiv += '<div class="apply-padding facets-faceted-navigation-item-optionlist-extra-wrapper">'
											appendDiv += '<a class="level4-collapse" data-target="#'+level3text+'" data-action="see-more-list">'
											appendDiv += '<span data-type="see-more" class="show-more-less">'
											appendDiv += "See More"
											appendDiv += "</span>"
											appendDiv += '<span data-type="see-less" class="show-more-less facets-faceted-navigation-item-alt-caption">'
											appendDiv += "See Less"
											appendDiv += "</span>"
											appendDiv += "</a>"
											appendDiv += "</div>"
					  					}
					  				}
					  				appendDiv += "</li>"
						  		})

					  		appendDiv += "</ul>"
					  	});
					  	
					  	appendDiv += "</div>"

					  	$('.extra-level-container').html(appendDiv)


				  	 }
				  	}
				  	//if Level2 has no subcategories, then hide whole nav when its clicked
				  	if(jQuery(e.currentTarget).hasClass('has-subcategories'))
			  		{
			  			//donothing
			  		}
			  		else{
			  			//console.log('do nothing')
			  			jQuery(e.currentTarget).removeClass("open");

			  			var flag = $('.header-menu-level1').children().hasClass('open');
					  	if(flag)
					  	{
					  		$('.header-menu-level1').find('li').removeClass("open");
					  		jQuery('#main').removeClass('nav-opened');
					  	}
			  			//$('.header-menu-level1').find('li').removeClass("open");	
			  		}
		  		}

			  }
			);

			// Desktop hover navigation with hover-intent delay
			var hoverIntentTimer = null;
			var hoverCloseTimer = null;
			var HOVER_DELAY = 150;
			var CLOSE_DELAY = 250;

			jQuery(document).on('mouseenter', '.header-menu-level1 > li.has-subcategories, .header-menu-level1 > li.subnav-right.has-subcategories', function() {
				if (Utils.isPhoneDevice() || Utils.isTabletDevice()) return;
				var $this = jQuery(this);
				clearTimeout(hoverIntentTimer);
				clearTimeout(hoverCloseTimer);
				// Close siblings immediately
				$this.siblings('.has-subcategories').removeClass('hover-open');
				$this.siblings('.subnav-right').removeClass('hover-open');
				$this.siblings('.has-subcategories').find('.extra-level-container').empty();
				hoverIntentTimer = setTimeout(function() {
					$this.addClass('hover-open');
					jQuery('#main').addClass('nav-opened');
				}, HOVER_DELAY);
			});
			jQuery(document).on('mouseleave', '.header-menu-level1 > li.has-subcategories, .header-menu-level1 > li.subnav-right.has-subcategories', function() {
				if (Utils.isPhoneDevice() || Utils.isTabletDevice()) return;
				var $this = jQuery(this);
				clearTimeout(hoverIntentTimer);
				hoverCloseTimer = setTimeout(function() {
					$this.removeClass('hover-open');
					$this.find('.extra-level-container').empty();
					$this.find('.hover-flyout-panel').empty().hide();
					$this.find('.hover-flyout-panel-l4').empty().hide();
					$this.find('.mfg-flyout-panel').empty().hide();
					$this.find('.mfg-flyout-panel-l4').empty().hide();
					$this.find('.mfg-flyout-panel-l5').empty().hide();
					$this.find('.hover-level2-active').removeClass('hover-level2-active');
					$this.find('.hover-l3-active').removeClass('hover-l3-active');
					$this.find('.hover-active').removeClass('hover-active');
					setTimeout(function() {
						if (!jQuery('.header-menu-level1 > li.hover-open').length) {
							jQuery('#main').removeClass('nav-opened');
						}
					}, 100);
				}, CLOSE_DELAY);
			});

			// Close hover menu when a take-to-that-page link is clicked on desktop
			jQuery(document).on('click', '.header-menu-level-container .take-to-that-page', function() {
				if (Utils.isPhoneDevice() || Utils.isTabletDevice()) return;
				jQuery('.header-menu-level1 > li').removeClass('hover-open');
				jQuery('.hover-active, .hover-level2-active, .hover-l3-active').removeClass('hover-active hover-level2-active hover-l3-active');
				jQuery('#main').removeClass('nav-opened');
			});

			// Categories: build Level 3 column on Level 2 hover
			// Flyout is placed in a sibling panel beside the scrollable .header-menu-level2
			jQuery(document).on('mouseenter', '.header-menu-level2 [data-action="categories-menu-level2"].has-subcategories', function() {
				var element = jQuery(this);
				var data_attr = element.attr('data-href');
				if(!data_attr) return;

				var level2Container = element.closest('.level2-container');
				if(!level2Container.length) return;

				// Create or reuse the flyout panel beside the scrollable list
				var flyoutPanel = level2Container.children('.hover-flyout-panel');
				if(!flyoutPanel.length) {
					flyoutPanel = jQuery('<div class="hover-flyout-panel"></div>');
					level2Container.append(flyoutPanel);
				}

				// Highlight active item
				element.siblings('.has-subcategories').removeClass('hover-level2-active');
				element.addClass('hover-level2-active');

				var nav_data = Configuration.navigationData;
				var all_level2_categories = [];

				_.each(nav_data, function(nav) {
					var categories = nav.categories;
					if(categories && categories.length > 0)
						all_level2_categories = all_level2_categories.concat(categories);
				});

				var find_category = _.findWhere(all_level2_categories, { href: data_attr });
				if(!find_category || !find_category.categories) return;

				var currentTouchpoint = Configuration.get('currentTouchpoint');
				var html = "<ul class='hover-col-list'>";
				html += "<li class='hover-col-all'><a class='take-to-that-page' data-action='take-action' data-hashtag='#"+find_category.href+"' data-touchpoint='home' href='"+find_category.href+"'>All "+find_category.text+"</a></li>";

				_.each(find_category.categories, function(level3) {
					var hasChildren = level3.categories && level3.categories.length > 0;
					html += "<li class='hover-col-item"+(hasChildren ? " has-subcategories" : "")+"'>";
					html += "<a "+(hasChildren ? "" : "class='take-to-that-page' data-action='take-action' ")+"data-hashtag='#"+level3.href+"' data-touchpoint='home' href='"+level3.href+"'>"+level3.text;
					if(hasChildren) html += "<i class='header-menu-chevron-icon'></i>";
					html += "</a>";

					if(hasChildren) {
						html += "<div class='hover-col-next'><ul class='hover-col-list'>";
						html += "<li class='hover-col-all'><a class='take-to-that-page' data-action='take-action' data-hashtag='#"+level3.href+"' data-touchpoint='home' href='"+level3.href+"'>All "+find_category.text+" > "+level3.text+"</a></li>";
						_.each(level3.categories, function(level4) {
							html += "<li><a class='take-to-that-page' data-action='take-action' data-hashtag='#"+level4.href+"' data-touchpoint='home' href='"+level4.href+"'>"+level4.text+"</a></li>";
						});
						html += "</ul></div>";
					}
					html += "</li>";
				});
				html += "</ul>";
				flyoutPanel.html(html).show();
			});

			// When hovering a non-subcategory item in any column, clear active highlights and hide flyouts
			jQuery(document).on('mouseenter', '.header-menu-level2 > li:not(.has-subcategories)', function() {
				var level2Container = jQuery(this).closest('.level2-container');
				level2Container.find('.hover-level2-active').removeClass('hover-level2-active');
				level2Container.children('.hover-flyout-panel').empty().hide();
				level2Container.children('.hover-flyout-panel-l4').empty().hide();
			});
			jQuery(document).on('mouseenter', '.hover-flyout-panel .hover-col-item:not(.has-subcategories), .hover-flyout-panel .hover-col-all', function() {
				var level2Container = jQuery(this).closest('.level2-container');
				level2Container.find('.hover-l3-active').removeClass('hover-l3-active');
				level2Container.children('.hover-flyout-panel-l4').empty().hide();
			});
			jQuery(document).on('mouseenter', '.manufacturer-header-menu-level2 > li:not(.has-subcategories)', function() {
				var level2Container = jQuery(this).closest('.level2-container');
				level2Container.find('.hover-active').removeClass('hover-active');
				level2Container.children('.mfg-flyout-panel').empty().hide();
				level2Container.children('.mfg-flyout-panel-l4').empty().hide();
				level2Container.children('.mfg-flyout-panel-l5').empty().hide();
			});
			jQuery(document).on('mouseenter', '.mfg-flyout-panel > li:not(.has-subcategories)', function() {
				jQuery(this).siblings('.has-subcategories').removeClass('hover-active');
				var level2Container = jQuery(this).closest('.level2-container');
				level2Container.children('.mfg-flyout-panel-l4').empty().hide();
				level2Container.children('.mfg-flyout-panel-l5').empty().hide();
			});
			jQuery(document).on('mouseenter', '.mfg-flyout-panel-l4 .hover-col-list > li:not(.has-subcategories)', function() {
				jQuery(this).siblings('.has-subcategories').removeClass('hover-active');
				var level2Container = jQuery(this).closest('.level2-container');
				level2Container.children('.mfg-flyout-panel-l5').empty().hide();
			});

			// Clear flyout when leaving a Level 2 item (unless entering another subcategory or the flyout itself)
			jQuery(document).on('mouseleave', '.header-menu-level2 [data-action="categories-menu-level2"].has-subcategories', function(e) {
				var relatedTarget = jQuery(e.relatedTarget);
				if(relatedTarget.closest('.hover-flyout-panel').length || relatedTarget.closest('.header-menu-level2').length) return;
				var level2Container = jQuery(this).closest('.level2-container');
				level2Container.children('.hover-flyout-panel').empty().hide();
				jQuery(this).removeClass('hover-level2-active');
			});
			jQuery(document).on('mouseleave', '.hover-flyout-panel', function(e) {
				var relatedTarget = jQuery(e.relatedTarget);
				if(relatedTarget.closest('.header-menu-level2').length || relatedTarget.closest('.hover-flyout-panel').length || relatedTarget.closest('.hover-flyout-panel-l4').length) return;
				jQuery(this).empty().hide();
				jQuery(this).closest('.level2-container').find('.hover-flyout-panel-l4').empty().hide();
				jQuery(this).closest('.level2-container').find('.hover-level2-active').removeClass('hover-level2-active');
			});

			// Level 4: on hover of a Level 3 item with children, show Level 4 in a third flex panel
			jQuery(document).on('mouseenter', '.hover-flyout-panel .hover-col-item.has-subcategories', function() {
				var $item = jQuery(this);
				var level2Container = $item.closest('.level2-container');
				var nextContent = $item.children('.hover-col-next');
				if(!nextContent.length) return;

				// Hide the inline hover-col-next (CSS absolute) — we'll use a flex panel instead
				nextContent.css('display', 'none');

				var l4Panel = level2Container.children('.hover-flyout-panel-l4');
				if(!l4Panel.length) {
					l4Panel = jQuery('<div class="hover-flyout-panel-l4"></div>');
					level2Container.append(l4Panel);
				}

				$item.siblings('.hover-col-item').removeClass('hover-l3-active');
				$item.addClass('hover-l3-active');

				l4Panel.html(nextContent.html()).show();
			});
			jQuery(document).on('mouseleave', '.hover-flyout-panel .hover-col-item.has-subcategories', function(e) {
				var relatedTarget = jQuery(e.relatedTarget);
				if(relatedTarget.closest('.hover-flyout-panel-l4').length || relatedTarget.closest('.hover-flyout-panel').length) return;
				var level2Container = jQuery(this).closest('.level2-container');
				level2Container.children('.hover-flyout-panel-l4').empty().hide();
				jQuery(this).removeClass('hover-l3-active');
			});
			jQuery(document).on('mouseleave', '.hover-flyout-panel-l4', function(e) {
				var relatedTarget = jQuery(e.relatedTarget);
				if(relatedTarget.closest('.hover-flyout-panel').length || relatedTarget.closest('.hover-flyout-panel-l4').length) return;
				jQuery(this).empty().hide();
				jQuery(this).closest('.level2-container').find('.hover-l3-active').removeClass('hover-l3-active');
			});

			// Manufacturers: hover for Col 1 (brands) -> Col 2 (product lines) via flex panel
			var mfgL2Timer = null;
			jQuery(document).on('mouseenter', '.manufacturer-header-menu-level2 > li.has-subcategories', function() {
				clearTimeout(mfgL2Timer);
				var $this = jQuery(this);
				$this.siblings('.has-subcategories').removeClass('hover-active');
				$this.addClass('hover-active');

				var level2Container = $this.closest('.level2-container');
				var subcategories = $this.children('.subcategories.manufacturer-level3');
				if(!subcategories.length) return;

				var mfgPanel = level2Container.children('.mfg-flyout-panel');
				if(!mfgPanel.length) {
					mfgPanel = jQuery('<ul class="mfg-flyout-panel"></ul>');
					level2Container.append(mfgPanel);
				}

				mfgPanel.html(subcategories.html()).show();
				level2Container.children('.mfg-flyout-panel-l4').empty().hide();
			});
			jQuery(document).on('mouseleave', '.manufacturer-header-menu-level2 > li.has-subcategories', function(e) {
				var $this = jQuery(this);
				var relatedTarget = jQuery(e.relatedTarget);
				if(relatedTarget.closest('.mfg-flyout-panel').length || relatedTarget.closest('.manufacturer-header-menu-level2').length) return;
				mfgL2Timer = setTimeout(function() {
					$this.removeClass('hover-active');
					var level2Container = $this.closest('.level2-container');
					level2Container.children('.mfg-flyout-panel').empty().hide();
					level2Container.children('.mfg-flyout-panel-l4').empty().hide();
				}, 300);
			});
			jQuery(document).on('mouseleave', '.mfg-flyout-panel', function(e) {
				var relatedTarget = jQuery(e.relatedTarget);
				if(relatedTarget.closest('.manufacturer-header-menu-level2').length || relatedTarget.closest('.mfg-flyout-panel').length || relatedTarget.closest('.mfg-flyout-panel-l4').length) return;
				var level2Container = jQuery(this).closest('.level2-container');
				jQuery(this).empty().hide();
				level2Container.children('.mfg-flyout-panel-l4').empty().hide();
				level2Container.find('.hover-active').removeClass('hover-active');
			});

			// Manufacturers: hover for Col 2 (product lines) -> Col 3 (subcategories) via flex panel
			var mfgL3Timer = null;
			jQuery(document).on('mouseenter', '.mfg-flyout-panel > li.has-subcategories, .mfg-flyout-panel [data-action="manufacturers-menu-level3"].has-subcategories', function() {
				clearTimeout(mfgL3Timer);
				var $this = jQuery(this);
				$this.siblings('.has-subcategories').removeClass('hover-active');
				$this.addClass('hover-active');

				var data_attr = $this.attr('data-href');
				var level2Container = $this.closest('.level2-container');
				var mfgPanel = level2Container.children('.mfg-flyout-panel');
				var parentBrandLi = level2Container.find('.manufacturer-header-menu-level2 > li.hover-active');
				var parents_parent_attr = parentBrandLi.attr('data-href');
				if(!data_attr || !parents_parent_attr) return;

				var nav_data = Configuration.navigationData;
				var all_level2_categories = [];

				_.each(nav_data, function(nav) {
					var categories = nav.categories;
					if(categories && categories.length > 0)
						all_level2_categories = all_level2_categories.concat(categories);
				});

				var find_secondlevel_menu = _.findWhere(all_level2_categories, { href: parents_parent_attr });
				if(!find_secondlevel_menu || !find_secondlevel_menu.categories) return;

				var find_thirdlevel_menu = _.findWhere(find_secondlevel_menu.categories, { href: data_attr });
				if(!find_thirdlevel_menu || !find_thirdlevel_menu.categories || find_thirdlevel_menu.categories.length === 0) return;

				var currentTouchpoint = Configuration.get('currentTouchpoint');
				var html = "<ul class='hover-col-list'>";
				html += "<li class='hover-col-all'><a class='take-to-that-page' data-action='take-action' data-hashtag='#"+find_thirdlevel_menu.href+"' data-touchpoint='home' href='"+find_thirdlevel_menu.href+"'>All "+find_thirdlevel_menu.text+"</a></li>";

				_.each(find_thirdlevel_menu.categories, function(level4) {
					var hasChildren = level4.categories && level4.categories.length > 0;
					html += "<li" + (hasChildren ? " class='has-subcategories'" : "") + " data-href='"+level4.href+"'><a class='" + (hasChildren ? "" : "take-to-that-page' data-action='take-action' ") + "data-hashtag='#"+level4.href+"' data-touchpoint='home' href='"+level4.href+"'>"+level4.text + (hasChildren ? "<i class='header-menu-chevron-icon'></i>" : "") + "</a></li>";
				});
				html += "</ul>";

				var l4Panel = level2Container.children('.mfg-flyout-panel-l4');
				if(!l4Panel.length) {
					l4Panel = jQuery('<div class="mfg-flyout-panel-l4"></div>');
					level2Container.append(l4Panel);
				}
				l4Panel.html(html).show();
				level2Container.children('.mfg-flyout-panel-l5').empty().hide();
			});
			jQuery(document).on('mouseleave', '.mfg-flyout-panel > li.has-subcategories, .mfg-flyout-panel [data-action="manufacturers-menu-level3"].has-subcategories', function(e) {
				var relatedTarget = jQuery(e.relatedTarget);
				if(relatedTarget.closest('.mfg-flyout-panel-l4').length || relatedTarget.closest('.mfg-flyout-panel').length) return;
				var $this = jQuery(this);
				mfgL3Timer = setTimeout(function() {
					$this.removeClass('hover-active');
					$this.closest('.level2-container').children('.mfg-flyout-panel-l4').empty().hide();
					$this.closest('.level2-container').children('.mfg-flyout-panel-l5').empty().hide();
				}, 300);
			});
			jQuery(document).on('mouseleave', '.mfg-flyout-panel-l4', function(e) {
				var relatedTarget = jQuery(e.relatedTarget);
				if(relatedTarget.closest('.mfg-flyout-panel').length || relatedTarget.closest('.mfg-flyout-panel-l4').length || relatedTarget.closest('.mfg-flyout-panel-l5').length) return;
				jQuery(this).empty().hide();
				jQuery(this).closest('.level2-container').children('.mfg-flyout-panel-l5').empty().hide();
				jQuery(this).closest('.level2-container').find('.mfg-flyout-panel .hover-active').removeClass('hover-active');
			});

			// Manufacturers: hover for Col 3 (subcategories in .mfg-flyout-panel-l4) -> Col 4 (Level 5) via flex panel
			var mfgL4Timer = null;
			jQuery(document).on('mouseenter', '.mfg-flyout-panel-l4 .hover-col-list > li.has-subcategories', function() {
				clearTimeout(mfgL4Timer);
				var $this = jQuery(this);
				$this.siblings('.has-subcategories').removeClass('hover-active');
				$this.addClass('hover-active');

				var data_attr = $this.attr('data-href');
				var level2Container = $this.closest('.level2-container');
				var parentBrandLi = level2Container.find('.manufacturer-header-menu-level2 > li.hover-active');
				var parents_parent_attr = parentBrandLi.attr('data-href');
				var parentProductLi = level2Container.find('.mfg-flyout-panel > li.hover-active');
				var parent_product_attr = parentProductLi.attr('data-href');
				if(!data_attr || !parents_parent_attr || !parent_product_attr) return;

				var nav_data = Configuration.navigationData;
				var all_level2_categories = [];
				_.each(nav_data, function(nav) {
					var categories = nav.categories;
					if(categories && categories.length > 0)
						all_level2_categories = all_level2_categories.concat(categories);
				});

				var find_brand = _.findWhere(all_level2_categories, { href: parents_parent_attr });
				if(!find_brand || !find_brand.categories) return;
				var find_product = _.findWhere(find_brand.categories, { href: parent_product_attr });
				if(!find_product || !find_product.categories) return;
				var find_sub = _.findWhere(find_product.categories, { href: data_attr });
				if(!find_sub || !find_sub.categories || find_sub.categories.length === 0) return;

				var html = "<ul class='hover-col-list'>";
				html += "<li class='hover-col-all'><a class='take-to-that-page' data-action='take-action' data-hashtag='#"+find_sub.href+"' data-touchpoint='home' href='"+find_sub.href+"'>All "+find_sub.text+"</a></li>";
				_.each(find_sub.categories, function(level5) {
					html += "<li><a class='take-to-that-page' data-action='take-action' data-hashtag='#"+level5.href+"' data-touchpoint='home' href='"+level5.href+"'>"+level5.text+"</a></li>";
				});
				html += "</ul>";

				var l5Panel = level2Container.children('.mfg-flyout-panel-l5');
				if(!l5Panel.length) {
					l5Panel = jQuery('<div class="mfg-flyout-panel-l5"></div>');
					level2Container.append(l5Panel);
				}
				l5Panel.html(html).show();
			});
			jQuery(document).on('mouseleave', '.mfg-flyout-panel-l4 .hover-col-list > li.has-subcategories', function(e) {
				var relatedTarget = jQuery(e.relatedTarget);
				if(relatedTarget.closest('.mfg-flyout-panel-l5').length || relatedTarget.closest('.mfg-flyout-panel-l4').length) return;
				var $this = jQuery(this);
				mfgL4Timer = setTimeout(function() {
					$this.removeClass('hover-active');
					$this.closest('.level2-container').children('.mfg-flyout-panel-l5').empty().hide();
				}, 300);
			});
			jQuery(document).on('mouseleave', '.mfg-flyout-panel-l5', function(e) {
				var relatedTarget = jQuery(e.relatedTarget);
				if(relatedTarget.closest('.mfg-flyout-panel-l4').length || relatedTarget.closest('.mfg-flyout-panel-l5').length) return;
				jQuery(this).empty().hide();
				jQuery(this).closest('.level2-container').find('.mfg-flyout-panel-l4 .hover-active').removeClass('hover-active');
			});

			HomeView.prototype.getContext = _.wrap(HomeView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);		

			//NewArrivals Date Range
			var NewArrivalsDateObj = new Date()
			,   NewArrivalsTodaysDate = NewArrivalsDateObj.getDate()
			,   NewArrivalsTodaysMonth = NewArrivalsDateObj.getMonth()+1
			,   NewArrivalsTodaysDay = NewArrivalsDateObj.getDay()
			,   NewArrivalsFinalThisDate = NewArrivalsTodaysMonth+"/"+NewArrivalsTodaysDate

			var NewArrivalsOneWeekAgo = new Date();
			NewArrivalsOneWeekAgo.setDate(NewArrivalsOneWeekAgo.getDate() - 6);
			var NewArrivalsOneWeekAgoDate = NewArrivalsOneWeekAgo.getDate()
			,   NewArrivalsOneWeekAgoMonth = NewArrivalsOneWeekAgo.getMonth()+1
			,   NewArrivalsFinalOneWeekAgoDate = NewArrivalsOneWeekAgoMonth+"/"+NewArrivalsOneWeekAgoDate

			var newArrivalsDateRange = NewArrivalsFinalOneWeekAgoDate+"-"+NewArrivalsFinalThisDate;

			//IncomingEquipment Date Range
			var IncomingEquipmentDateObj = new Date()
			,   IncomingEquipmentTodaysDate = IncomingEquipmentDateObj.getDate()
			,   IncomingEquipmentTodaysMonth = IncomingEquipmentDateObj.getMonth()+1
			,   IncomingEquipmentTodaysDay = IncomingEquipmentDateObj.getDay()

			var IncomingEquipmentTomorrowDateObj = IncomingEquipmentDateObj.setDate(IncomingEquipmentDateObj.getDate() + 1);
			var first = IncomingEquipmentDateObj.getDate() - IncomingEquipmentDateObj.getDay(); 
			//var last = first + 6; 

			//console.log(new Date(IncomingEquipmentTomorrowDateObj))

			var firstday = new Date(IncomingEquipmentDateObj.setDate(first)).toUTCString()
			,   firstDayFormatting = new Date(firstday)
			,   firstdayIncomingEquipmentTodaysDate = firstDayFormatting.getDate()
			,   firstdayIncomingEquipmentTodaysMonth = firstDayFormatting.getMonth()+1
			,   finalIncomingEquipmentStartDate = firstdayIncomingEquipmentTodaysMonth+"/"+firstdayIncomingEquipmentTodaysDate
			,   lastday = new Date(IncomingEquipmentTomorrowDateObj).toUTCString()
			,   lastdayFormatting = new Date(lastday)
			,   lastdayIncomingEquipmentTodaysDate = lastdayFormatting.getDate()
			,   lastdayIncomingEquipmentTodaysMonth = lastdayFormatting.getMonth()+1
			,   finalIncomingEquipmentEndDate = lastdayIncomingEquipmentTodaysMonth+"/"+lastdayIncomingEquipmentTodaysDate
			
			var incomingEquipmentDateRange = finalIncomingEquipmentStartDate+"-"+finalIncomingEquipmentEndDate;

			//console.log(incomingEquipmentDateRange)

			_.extend(result, {
							isPhoneDevice: Utils.isPhoneDevice(),
							newArrivalsDateRange : newArrivalsDateRange,
							incomingEquipmentDateRange : incomingEquipmentDateRange						
						});

			//console.log(result)
			return result;
			});


			HeaderView.prototype.showSidebar = HeaderViewExt.showSidebar;
			//FacetsFacetedNavigationItemView.prototype.renderFacets = HeaderViewExt.renderFacets;
			HeaderView.prototype.hideSidebar = HeaderViewExt.hideSidebar;

			FacetsFacetedNavigationView.addChildViews({
		            'Facets.FacetedNavigationItems': function wrapperFunction(options) {
		            	const { translator } = this.options; // FacetsHelper.parseUrl(this.options.translatorUrl, this.options.translatorConfig, this.options.translator.categoryUrl)
			            let ordered_facets =
			                this.options.facets &&
			                this.options.facets.sort(function(a, b) {
			                    // Default Priority is 0
			                    return (
			                        (translator.getFacetConfig(b.url || b.id).priority || 0) -
			                        (translator.getFacetConfig(a.url || a.id).priority || 0)
			                    );
			                });

			            // if prices aren't to be shown we take out price related facet
			            const hidden_facet_names = Configuration.get('loginToSeePrices.hiddenFacetNames', []);

			            if (ProfileModel.getInstance().hidePrices()) {
			                ordered_facets = _.reject(ordered_facets, function(item) {
			                    return _.indexOf(hidden_facet_names, item.id) >= 0;
			                });
			            }

			            //Customization to exclude facets based on configuration
			             const exclude_facets = Configuration.get('ExcludedFacets');
			             const exclude_facets_config = exclude_facets.config;
			             const self = this;

			             const final_facets = _.filter(ordered_facets, function(name) {
			                return !_.findWhere(exclude_facets_config, {
			                    facetid: name.id
			                });
			            });

			            //console.log(final_facets)
			            return new BackboneCollectionView({
			                childView: FacetsFacetedNavigationItemView,
			                viewsPerRow: 1,
			                collection: new Backbone.Collection(final_facets.reverse()),
			                childViewOptions: {
			                    translator: translator
			                }
			            });
		            }
		        });

			FacetsBrowseView.prototype.getContext = _.wrap(FacetsBrowseView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);		

			 var isCategoryCommercePage = false
			 ,   isManufacturerCommercePage = false
			 ,   hasSubcategories = false
			 ,   displayMoreSubcatLink = false
			 ,   applyManufacturerTemplate = false
			 ,   applySystem8Template = false
			 ,   systemSubcategoriesRequired = false
			 ,   systemPageName = ''
			 ,   applyCirclesToSubcategory = false
			 ,   applyBannerToSubcategory = false
			 ,   applyVisualSystemPageTemplate = false


			 if (this.isCategoryPage) {
			 	var currentCategory = this.model.get('category');
			 	var currentCategorySubsCount = currentCategory.get('categories');
			 	

			 	var top_category_id = Configuration.TopCategoryId
			 	,   top_manufacturer_id = Configuration.TopManufacturerId
			 	,   manufacturer_data = Configuration.ManufacturerPage
			 	,   manufacturer_config_data = manufacturer_data.config
			 	,   system8_data = Configuration.System8Page
			 	,   system8_config_data = system8_data.config
			 	,   subCategoryCircles = Configuration.SubcategoriesCircles
			    ,   subCategoryCirclesConfig = subCategoryCircles.config
			    ,   visualSystemPage_data = Configuration.VisualSystemPage
			    ,   visualSystem8Page_config_data = visualSystemPage_data.config;

			    //console.log(manufacturer_config_data)
			 	

			 	if(currentCategorySubsCount.length > 0)
			 		hasSubcategories = true;
			 	if(currentCategorySubsCount.length > 8)
			 		displayMoreSubcatLink = true;

			 	if(currentCategory.get('internalid') == top_category_id.config)
			 		isCategoryCommercePage = true
			 	else if(currentCategory.get('internalid') == top_manufacturer_id.config)
			 		isManufacturerCommercePage = true;

			 	var findMatchingManufacturer = _.findWhere(manufacturer_config_data, {
                    urlfragment: currentCategory.get('urlfragment')
                });

                var findMatchingSystem8 = _.findWhere(system8_config_data, {
                    urlfragment: currentCategory.get('urlfragment')
                });

                //console.log(subCategoryCirclesConfig)
                var findMatchingSubCategoryCircles = _.findWhere(subCategoryCirclesConfig, {
                    categoryurl: currentCategory.get('urlfragment')
                });

                //console.log(findMatchingSubCategoryCircles)

                
                var findMatchingVisualSystemPage = _.findWhere(visualSystem8Page_config_data, {
                    pageinternalid: currentCategory.get('internalid')
                });

                //console.log(this)
                //console.log(currentCategory.get('categories'))
                //console.log(visualSystem8Page_config_data);

                //console.log(findMatchingManufacturer)
                if(findMatchingManufacturer)
                applyManufacturerTemplate = true;

            	if(findMatchingSystem8)
            	{
            		applySystem8Template = true;
            		if(findMatchingSystem8.subcategoryrequired)
            			systemSubcategoriesRequired = true;
            	}

            	if(findMatchingSubCategoryCircles)
            	{
            		applyCirclesToSubcategory = true;
            		if(findMatchingSubCategoryCircles.bannerrequired)
            			applyBannerToSubcategory = true;
            	}

            	if(systemSubcategoriesRequired)
            	{
            		var curCat = this.model.get('category')
            		systemPageName = curCat.get('name');
            		//console.log(systemPageName)
            	}
            	
                if(findMatchingVisualSystemPage)
	                applyVisualSystemPageTemplate = true;
				 }	

			_.extend(result, {
							isCategoryCommercePage : isCategoryCommercePage,
							isManufacturerCommercePage : isManufacturerCommercePage,
							isPhoneDevice : Utils.isPhoneDevice(),
							isTabletPhoneDevice : Utils.isTabletDevice() || Utils.isPhoneDevice(),
							displayMoreSubcatLink : displayMoreSubcatLink,
							hasSubcategories: hasSubcategories,
							applyManufacturerTemplate : applyManufacturerTemplate,
							applySystem8Template : applySystem8Template,
							systemSubcategoriesRequired : systemSubcategoriesRequired,
							systemPageName : systemPageName,
							applyCirclesToSubcategory : hasSubcategories ? applyCirclesToSubcategory : false,
							applyBannerToSubcategory : applyBannerToSubcategory,
							applyVisualSystemPageTemplate : applyVisualSystemPageTemplate
						});

			//console.log(result)
			return result;
			});

			
			FacetsBrowseCategoryHeadingView.prototype.getContext = _.wrap(FacetsBrowseCategoryHeadingView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);		

			 var isTopCategoryPage = false
			 ,   applySystem8Template = false

			 var top_category_id = Configuration.TopCategoryId
			 ,   top_manufacturer_id = Configuration.TopManufacturerId
			 	

		 	,   system8_data = Configuration.System8Page
		 	,   system8_config_data = system8_data.config;

		 	//console.log(top_manufacturer_id.config)

		 	var currentCategory = this.model;

		 	var findMatchingSystem8 = _.findWhere(system8_config_data, {
                    urlfragment: currentCategory.get('urlfragment')
                });

		 	//console.log(currentCategory.get('internalid'))

		 	if(findMatchingSystem8)
                applySystem8Template = true;

		 	
		 	if(currentCategory.get('internalid') == top_category_id.config || currentCategory.get('internalid') == top_manufacturer_id.config)
		 		isTopCategoryPage = true

			_.extend(result, {
							pageTitle : this.model.get('pagetitle'),
							isTopCategoryPage : isTopCategoryPage,
							applySystem8Template : applySystem8Template,
							isPhoneDevice : Utils.isPhoneDevice(),
							isTabletPhoneDevice : Utils.isTabletDevice() || Utils.isPhoneDevice()
						});

			//console.log(result)
			return result;
			});


			FacetsCategoryCellView.prototype.getContext = _.wrap(FacetsCategoryCellView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);		

			var isTopCategoryPage = false
			 var currentCategory = this.model;
			 var origin = this.options.origin;

			 	if(currentCategory.get('parenturl') == "/categories" || currentCategory.get('parenturl') == '/manufacturers')
			 		isTopCategoryPage = true

			 	if(origin && origin == 'manufacturerpage')
			 		isTopCategoryPage = true

			_.extend(result, {
							isTopCategoryPage : isTopCategoryPage
						});

			//console.log(result)
			return result;
			});

			layout.addToViewEventsDefinition(
						'Facets.Browse.View',
						'click [data-action="show-next-subcat"]',
						function (el) {
							//console.log(el);
							$('.prev-subcat').show();
							$('.facet-category-cells').animate({
						        scrollLeft: "+=200px"
						      }, "slow");
							var windowWidth = jQuery(window).width();
							if(windowWidth < 768)
							$('.facet-category-cells').css('width','90%');
							else
							$('.facet-category-cells').css('width','95%');	
						}
				);

			layout.addToViewEventsDefinition(
						'Facets.Browse.View',
						'click [data-action="show-previous-subcat"]',
						function (el) {

							$('.facet-category-cells').animate({
						        scrollLeft: "-=200px"
						      }, "slow");
						}
				);


			layout.addToViewEventsDefinition(
						'Facets.Browse.CategoryHeading.View',
						'click [data-action="view-more-content"]',
						function (el) {
							//console.log(el)
							//var currentAttrValue = jQuery(this).attr('id');
							if($('.category-page-description-section #cat-desc').hasClass('open'))
							{
								$('.category-page-description-section #cat-desc').removeClass('open'); 
								$('.category-page-description-section #cat-desc').css('height','52px');
								$('.category-page-description-section #cat-desc').css('overflow','hidden');
								$('.category-page-description-section .view-less-minus-icon').css('display','none')
								$('.category-page-description-section .view-more-plus-icon').css('display','block')
								//$('.plus-icon .view-m-s').text('View More');
							}
							else{
								$('.category-page-description-section #cat-desc').slideDown(300).addClass('open'); 
								$('.category-page-description-section #cat-desc').css('height','auto');
								$('.category-page-description-section #cat-desc').css('overflow','auto');
								$('.category-page-description-section .view-less-minus-icon').css('display','block')
								$('.category-page-description-section .view-more-plus-icon').css('display','none')
								//$('.plus-icon .view-m-s').text('View Less');
							}
						}
				);

			layout.addChildView('ManufacturerPage.View', function () 
		        {
		        	var plp = container.getComponent('PLP');
					var categoryinfo = plp.getCategoryInfo();
					if(categoryinfo)
					{
						
						var manufacturer_data = Configuration.ManufacturerPage
			 	        ,   manufacturer_config_data = manufacturer_data.config;

						var findMatchingManufacturer = _.findWhere(manufacturer_config_data, {
		                    urlfragment: categoryinfo.urlfragment
		                });

		                //console.log(findMatchingManufacturer)

						return new C3ShoppingExtensionsManufacturerPageView(
		                {
		                	application: environment.application,
		                	container : container,
		                	category : categoryinfo,
		                	configuration : Configuration,
		                	manufacturerId : findMatchingManufacturer ? findMatchingManufacturer.id : '',
		                	tradeinmanufacturerid : findMatchingManufacturer ? findMatchingManufacturer.tradeinmanufacturerid : '',
		                	tradeincategoryid : findMatchingManufacturer ? findMatchingManufacturer.tradeincategoryid : ''
		                });
						
					}

		        });


			  layout.addChildView('System8.View', function () 
		        {
		        	var plp = container.getComponent('PLP');
					var categoryinfo = plp.getCategoryInfo();
					if(categoryinfo)
					{
						
						var system8_data = Configuration.System8Page
			 			,   system8_config_data = system8_data.config;

						 var findMatchingSystem8 = _.findWhere(system8_config_data, {
		                    urlfragment: categoryinfo.urlfragment
		                });

		               // console.log(findMatchingSystem8)

						return new C3ShoppingExtensionsSystem8PageView(
		                {
		                	application: environment.application,
		                	category : categoryinfo,
		                	configuration : Configuration
		                });
						
					}

		        });

			  layout.addChildView('Facets.System.CategoryCells', function () 
		        {
		        	var plp = container.getComponent('PLP');
					var categoryinfo = plp.getCategoryInfo();
					if(categoryinfo)
					{		
						//console.log(categoryinfo)
						var siblings = categoryinfo.siblings
						//var current_siblings = [];

						if(siblings.length > 0)
						{

							return new C3ShoppingExtensionsSystem8PageListView(
		                	{
		                	application: environment.application,
		                	categoryinfo : categoryinfo,
		                	subcategoryinfo : siblings
		                	});
						}		
						
					}

		        });


			layout.addChildView('SubCategory.Circles.View', function () 
		        {
		        	var plp = container.getComponent('PLP');
					var categoryinfo = plp.getCategoryInfo();
					if(categoryinfo)
					{

						var isPhoneDevice = Utils.isPhoneDevice()
						,   viewsPerRow = 6;

						if(isPhoneDevice)
						viewsPerRow = 3;

						//console.log(viewsPerRow)
		                return new BackboneCollectionView({
			                application: environment.application,
			               /* keywords: this.translator.getOptionValue('keywords'),*/
			                collection: categoryinfo.categories,
			                viewsPerRow: viewsPerRow,
			               // childTemplate: facets_item_cell_grid_tpl,
			                childTemplate : c3_shoppingextensions_subcategory_circles_tpl,
							childView: C3ShoppingExtensionsSubCategoryCirclesView,
			                cellTemplate: facets_items_collection_view_cell_tpl,
						    rowTemplate: facets_items_collection_view_row_tpl,
						    template: facets_items_collection_tpl,
						    childViewOptions:{
						    	application: environment.application,
						    	origin: 'subcategory-circles-page'
						    }
			            });



					}

		        });


			layout.addChildView('Facets.Category.CategoryCells', function ()
		        {
		        	var plp = container.getComponent('PLP');
					var categoryinfo = plp.getCategoryInfo();
					if(categoryinfo)
					{

						var isPhoneDevice = Utils.isPhoneDevice()
						,   viewsPerRow = 6;

						if(isPhoneDevice)
						viewsPerRow = 2;

						//console.log(categoryinfo)
		                return new BackboneCollectionView({
			                application: environment.application,
			               /* keywords: this.translator.getOptionValue('keywords'),*/
			                collection: categoryinfo.categories,
			                viewsPerRow: viewsPerRow,
			                childTemplate: facets_custom_categories_cell_grid_tpl,
			                //childView: FacetsCategoryCellView,
			                childView: C3ShoppingExtensionsSubCategoryCirclesView,
			                cellTemplate: facets_items_collection_view_cell_tpl,
						    rowTemplate: facets_items_collection_view_row_tpl,
						    template: facets_items_collection_tpl,
						    childViewOptions:{
						    	application: environment.application,
						    	origin: 'category-circles-page'
						    }
			            });
						
						
						
					}

		        });

			layout.addChildView('SubCategory.Breadcrumb', function () 
		        {
		        	var plp = container.getComponent('PLP');
					var categoryinfo = plp.getCategoryInfo();
					if(categoryinfo)
					{
						//console.log(categoryinfo)
						const breadcrumb = [];

		       	    	 breadcrumb[0] = {
				                href : '/',
				                'data-hashtag' : '#',
				                'data-touchpoint': "home",
				                hasDataHashtag: true,
				                hasDataTouchpoint: true,
				                text: "Home"
				          }

			            const list = categoryinfo.breadcrumb;

			            _.each(list, function(bread) {
			                breadcrumb.push({
			                    text: bread.name,
			                    href: bread.fullurl
			                });
			            });
			            //console.log(breadcrumb)
		                return new GlobalViewsBreadcrumbView({
			        			 pages: breadcrumb 
			        		});
						
						
					}

		        });

		
		FacetsFacetedNavigationItemView.prototype.getContext = _.wrap(FacetsFacetedNavigationItemView.prototype.getContext, function (fn) {
			var result = fn.apply(this, arguments);		

			_.extend(result, {					
							isPhoneDevice : Utils.isPhoneDevice()
						});


			//console.log(result);
			return result;
			});


			var self = this;

			layout.addToViewEventsDefinition(
				'Facets.ItemCell.View',
				'click [data-action="item-quick-view"]',
			function (e) 
			{
				//console.log(e)
				self.showQuickView(e,container,layout);
			});

			layout.addToViewEventsDefinition(
					'Header.Menu.View',
					'click [data-action="push-menu1"]',
					function (el) {
					el.preventDefault();
					el.stopPropagation();

					var target = el.currentTarget
					,   parent = $(target).parent('.has-subcategories');

					//console.log(parent)

					var siblings = parent.siblings();
					//console.log(siblings)
					if(siblings.hasClass('opened'))
					{
						var siblings_children = siblings.children('ul.subcategories')
						,   siblings_children_child = siblings_children.children('li.opened') 
						
						if(siblings_children_child.length > 0)
						{
							siblings_children_child.removeClass('opened')
							siblings_children_child.children('ul.subcategories').css('display','none');
						}	
						siblings.removeClass('opened')
						siblings.children('ul.subcategories').css('display','none');
					}
					/*if($('.header-sidebar-menu').children().hasClass('opened'))
					{
						var siblings = parent.siblings();
						console.log(siblings)
					   $('.header-sidebar-menu').children().removeClass('opened')	
					}*/
					
					if(parent.children('ul.subcategories').css('display') == 'none')
					{
						//console.log(parent)
						parent.addClass('opened')
					}
					else
					{
						var parent_children = parent.children('ul.subcategories')
						,   parent_children_child = parent_children.children('li.opened')

						if(parent_children_child.length > 0)
						{
							parent_children_child.removeClass('opened')
							parent_children_child.children('ul.subcategories').css('display','none');
						}	
						parent.removeClass('opened')
						//parent.children('ul.subcategories').css('display','none');
					}
					

					var find_ul = parent.find(".subcategories").first();
					//console.log(find_ul)
					$(find_ul).slideToggle(200)
		        	//console.log(find_ul)
					}
			);

			layout.addToViewEventsDefinition(
				'ProductDetailToQuote.View',
				'click [data-action="show-login-register-popup"]',
			function (e) 
			{
				e.stopPropagation();
				e.preventDefault();

				var view = new LoginRegisterView({
					application: layout.application
				});

				if (view)
				layout.showContent(view, {showInModal: true});

				// Handle both hash-based (local) and pushState (live) routing
				var currentUrl;
				if (window.location.hash) {
					// Hash-based routing (local): #product-url?params
					currentUrl = window.location.hash.substring(1); // remove the #
				} else {
					// pushState routing (live): /product-url?params
					currentUrl = window.location.pathname.substring(1) + window.location.search;
				}
				
				// Append addtoquote=T to existing params
				var returnUrl;
				if (currentUrl.indexOf('?') > -1) {
					returnUrl = currentUrl + '&addtoquote=T';
				} else {
					returnUrl = currentUrl + '?addtoquote=T';
				}
				Backbone.history.navigate(returnUrl, { trigger: false });
			});	

			layout.addToViewEventsDefinition(
				'Header.MiniCartItemCell.View',
				'click [data-action="show-login-register-popup"]',
			function (e) 
			{
				//console.log(e)
				e.stopPropagation();
				e.preventDefault();

				var view = new LoginRegisterView({
					application: layout.application
				});

				if (view)
				layout.showContent(view, {showInModal: true});
			});	

			/*layout.addToViewContextDefinition('Header.MiniCartItemCell.View', 'showMiniCartItemOOSMessage', 'boolean', function(context) {
			    
			    //console.log(context.line.item)        
	            var cartItemOOS = false
	            ,   line = context.line
	            ,   itemInfo = line.item
	            ,   type = itemInfo.itemtype
				,   qtyAvailableInv = itemInfo.custitem_qty_available_inv
			    ,   qtyAvailableKit = itemInfo.custitem_qty_available_kit 
				
				//console.log(itemInfo)
			    if(type == 'Kit')
				{
					if(qtyAvailableKit <= 1)
					cartItemOOS = true;
				}
				else if(type == 'InvtPart')
				{
					if(qtyAvailableInv <= 1)
					cartItemOOS = true;
				}

	            //console.log(cartItemOOS)

	            return cartItemOOS;
	      });*/ 

			layout.addToViewEventsDefinition(
				'Facets.ItemCell.View',
				'click [data-action="show-login-register-popup"]',
			function (e) 
			{
				e.stopPropagation();
				e.preventDefault();

				var view = new LoginRegisterView({
					application: layout.application
				});

				if (view)
				layout.showContent(view, {showInModal: true});
			});

			layout.addToViewEventsDefinition(
				'Facets.ItemCell.View',
				'click [data-action="minus"]',
			function (e) 
			{
				const $element = jQuery(e.currentTarget);
		        const quantity_input = $element.parent().find('.item-quantity-value');
		       	const find_title_ele = $element.closest('.e2');
		        const old_value = quantity_input.text();
		       	const cart = container.getComponent('Cart');
		    	var lines=[];

		        if(old_value==1 )
		        {
		        	var parentEle = $element.parent('.plus-icon');
			        if(parentEle.hasClass('expand-plus-icon'))
			        parentEle.removeClass('expand-plus-icon');

		        	find_title_ele.removeClass('newly-added-css');
		        	let new_val = parseFloat(old_value) - 1;
					quantity_input.text(new_val);
		        	$element.attr("style","display:none !important;");
		        	quantity_input.hide();
		        }
		        else if(old_value>1 ){
		        	let new_val = parseFloat(old_value) - 1;
		        	quantity_input.text(new_val);

		        	if(old_value == 2)
		        	{
		        		var trashCane = $element.parent().find('.product-trash-tray');
				    	var button_minus = $element.parent().find('.minus-button');
				    	//console.log(button_minus)
				    	button_minus.attr("style","display:none !important;");
				    	trashCane.show();
				    	quantity_input.css('text-align','left');
			        	
		        	}
		        }
		    	var internalID=quantity_input.attr("data-id");
				
				var liveOrder = LiveOrderModel.getInstance();
				
				var lineData=liveOrder.get('lines').filter(function(line)
				{	
					return line.get('item').get('internalid') == internalID;
		       	});
		       	var lineQuantity=lineData[0].get('quantity');
		       	
		       	if(lineQuantity==1)
		       		liveOrder.removeLine(
		       		lineData[0].set('quantity',parseFloat(lineQuantity)-1));
		    	else
		    	{
		    		liveOrder.updateLine(
		       		lineData[0].set('quantity',parseFloat(lineQuantity)-1));
		       		setTimeout(function(){
		    			if(!Utils.isPhoneDevice())
		    				jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
		    		}, 1000);
		    	}

		    	//Snippet for GTM DataLayer
                var cartLinesDL = liveOrder.get('lines')
                ,   cartLinesModelsDL = cartLinesDL.models
                ,   finalCartArray = []

                _.each(cartLinesModelsDL, function(line) {
                    var lineItem = line.get('item')
                    ,   lineItemName = lineItem.get('displayname')
                    ,   lineItemSKU = lineItem.get('itemid')
                    ,   lineQty = line.get('quantity')
                    ,   lineRate = line.get('rate')
					,   lineGroup = lineItem.get('custitemproduct_category')
					,   lineCategory =  lineItem.get('custitem168')

					finalCartArray.push({
					    'item': lineItemSKU,
					    'quantity':  lineQty,
					    'price': lineRate,
					    'unique_id': lineItemSKU,
					    'ProductGroup' : lineGroup,
					    'ProductCategory' : lineCategory

					})
                });

                const gtm = GoogleTagManager;
                const eventName = 'cartInfo';
                 const eventData = {
                    event: eventName,
                    cartUpdates: finalCartArray
                 }
                 Tracker.trigger(eventName, eventData);
                 gtm.pushData(eventData);
                 //console.log(gtm.win)

                //console.log(finalCartArray)
                /*var _etmc = [];
				_etmc.push(['trackCart', {
				    'cart': finalCartArray
				}]);*/
				//setTimeout(function() { 
	                var appendParentElement = $('.append-abandoned-cart-items')
	                appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
	             //}, 1000); 
			});


			layout.addToViewEventsDefinition(
				'Facets.ItemCell.View',
				'click [data-action="plus"]',
			function (e) 
			{
				var self = this;

				var $element = jQuery(e.currentTarget);
		        var quantity_input = $element.parent().find('.item-quantity-value');
		        var button_minus = $element.parent().find('.minus-button');
		       	var find_title_ele = $element.closest('.e2');
		       	var cart = container.getComponent('Cart');
		    	var lines=[];

		    	var itemQtyInCurrentOrder = 0;

		    	var liveOrder = LiveOrderModel.getInstance();
				//console.log(self.model.get('_id'))

				var internalID=quantity_input.attr("data-id");

				//console.log(internalID)
				
				var lineData=liveOrder.get('lines').filter(function(line)
				{	
					return line.get('item').get('internalid') == internalID;
		       	});
		       	
		       	if(lineData.length > 0)
		       	{
		       	var lineQuantity=lineData[0].get('quantity');
		       	itemQtyInCurrentOrder = lineQuantity;
		       	}

			    var elementParent = $element.parent('.plus-icon');		
				//console.log(elementParent)

		    	var trashCane = $element.parent().find('.product-trash-tray');
		    	
		       // console.log(find_title_ele)
		        quantity_input.show();
		       // button_minus.show();

		        var parentEle = $element.parent('.plus-icon');
		        if(!(parentEle.hasClass('expand-plus-icon')))
		        parentEle.addClass('expand-plus-icon');

		        find_title_ele.addClass('newly-added-css');
		        
		        var old_value = quantity_input.text();

		         if(elementParent.hasClass('add-to-cart-buttons-opened'))
	       		 {
				var new_val = parseFloat(old_value) == 0 ? 1 : parseFloat(old_value)+1; 
				quantity_input.text(new_val);
				}
				
				var quantity = quantity_input.text();
				var internalID=quantity_input.attr("data-id");


				if(quantity == 1)
		        {
		        	trashCane.show();
		        	button_minus.hide();
		        	quantity_input.css('text-align','left');
		        	
		        }
		        else	
		        {
		        	 button_minus.show();
		        	trashCane.hide();
		        	quantity_input.css('text-align','center');
		        }

		       // console.log(quantity)
				
				if(quantity>0)
				{
					if(itemQtyInCurrentOrder && !(elementParent.hasClass('add-to-cart-buttons-opened')))
					{
						$element.text('+');
						$element.removeClass('plus-button-additional');

						elementParent.addClass('add-to-cart-buttons-opened');
						elementParent.removeClass('plus-icon-additional');

					}else
					{
						var lineData={quantity: parseFloat(1),
							  		  item: {internalid: parseFloat(internalID)}
						};
						lines.push(lineData);
						SC.loadingIndicatorShow();
						cart.addLines({lines: lines}).then(function() {
							SC.loadingIndicatorHide();
							if(!Utils.isPhoneDevice())
							jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");


							//Snippet for GTM DataLayer
	                        var cartLinesDL = liveOrder.get('lines')
	                        ,   cartLinesModelsDL = cartLinesDL.models
	                        ,   finalCartArray = []

	                        _.each(cartLinesModelsDL, function(line) {
	                            var lineItem = line.get('item')
	                            ,   lineItemName = lineItem.get('displayname')
	                            ,   lineItemSKU = lineItem.get('itemid')
	                            ,   lineQty = line.get('quantity')
	                            ,   lineRate = line.get('rate')
								,   lineGroup = lineItem.get('custitemproduct_category')
								,   lineCategory =  lineItem.get('custitem168')

								finalCartArray.push({
								    'item': lineItemSKU,
								    'quantity':  lineQty,
								    'price': lineRate,
								    'unique_id': lineItemSKU,
								    'ProductGroup' : lineGroup,
								    'ProductCategory' : lineCategory

								})
	                        });

	                        const gtm = GoogleTagManager;
	                        const eventName = 'cartInfo';
	                         const eventData = {
	                            event: eventName,
	                            cartUpdates: finalCartArray
	                         }
	                         Tracker.trigger(eventName, eventData);
	                         gtm.pushData(eventData);
	                         //console.log(gtm.win)

	                        //console.log(finalCartArray)
	                        /*var _etmc = [];
							_etmc.push(['trackCart', {
							    'cart': finalCartArray
							}]);*/

							//setTimeout(function() { 
                            var appendParentElement = $('.append-abandoned-cart-items')
                            appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
                         //}, 1000); 

						});
						elementParent.addClass('add-to-cart-buttons-opened');	
					}
				}
			});	

		},
		showQuickView:function showQuickView(e,container,layout)
		{


		if(Utils.isPhoneDevice())
		{
		//	var tt = $('.layout-container').find('.modal');
			//console.log(tparent.children('#modal'))
			/*console.log(Utils.isPhoneDevice())
			$('.product-details-quickview').addClass('test');*/
		}

						
		var self = this;
		var $element = jQuery(e.currentTarget)
		var url = $element.attr('data-url');
		var lightboxURL = $element.attr('data-lightbox-url');
		var product = new ProductModel();
    	var promise = jQuery.Deferred();
    	var item = product.get('item');

    	//console.log(lightboxURL)
    	
		item.fetch({
	        data: {url:lightboxURL},
	        killerId: AjaxRequestsKiller.getKillerId(),
	        pageGeneratorPreload: true
	    }).then(
	        // Success function
	        function(data, _result, jqXhr) {
	        	//console.log(data)
	           if (!item.isNew()) 
	           	{
	             	if (item.get('urlcomponent') &&
	                    SC.ENVIRONMENT.jsEnvironment === 'server') {
	                 	    nsglobal.statusCode = 301;
	                        nsglobal.location = Utils.addSlashToURL(product.generateUrl());
	                }
	               if (data.corrections && data.corrections.length > 0) 
	               {
		               if ( item.get('urlcomponent') &&
		                   SC.ENVIRONMENT.jsEnvironment === 'server') {
		                    	nsglobal.statusCode = 301;
		                        nsglobal.location =
		                        Utils.addSlashToURL(data.corrections[0].url) +
		                        product.getQuery();
		                }else 
		                {
	                       var view = new GroupAddToCart({
								application: container ,model:product
							});
							if (view)
								layout.showContent(view, {showInModal: true})
		                
		                    promise.reject();
		                }
	                }
	                	// self.bindModel();
	                	promise.resolve();
                } 
                else if (jqXhr.status >= 500) {
                   	// application.getLayout().internalError();
                   	promise.reject();
                }
                else if (jqXhr.responseJSON.errorCode !== 'ERR_USER_SESSION_TIMED_OUT') 
                {
                    	// We just show the 404 page
                    	// application.getLayout().notFound();
                   		promise.reject();
                }
            },
	        // Error function
	        function(jqXhr) 
	        {
	            // this will stop the ErrorManagment module to process this error
	            // as we are taking care of it
	            jqXhr.preventDefault = true;
				if (jqXhr.status >= 500) {
	                // application.getLayout().internalError();
	                promise.reject();
	            } else if (jqXhr.responseJSON.errorCode !== 'ERR_USER_SESSION_TIMED_OUT') {
	                // We just show the 404 page
	                // application.getLayout().notFound();
	                promise.reject();
	            }
	        });
	   		//$('#site-footer').addClass('remove-footer-positioning')
            return promise;	
	}
	};
});
